var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsiaPacificCore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400.337,
    height: 199.589,
    viewBox: "0 0 400.337 199.589",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5615",
    "data-name": "Group 5615",
    transform: "translate(-1202.112 -656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7207",
    "data-name": "Path 7207",
    d: "M398.459,173.189l1.79,2.38-6.21,4.42.85-2.72,2.55-2.55v-3.83l1.02-.42Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7208",
    "data-name": "Path 7208",
    d: "M392.289,123.489l-1.38.47-3.44-2.47,1.32-.09Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7209",
    "data-name": "Path 7209",
    d: "M391.489,179.649v1.7l-9.95,6.55-2.98-1.7Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7210",
    "data-name": "Path 7210",
    d: "M389.749,123.949v1.72l-2.96,1.66-1.7-1.02Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7211",
    "data-name": "Path 7211",
    d: "M387.459,133.129l-3.83-.78-4.2-4.1-3.24,2.98-1.7-.6v-9.17l8.45,4.42-.23,2.51Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7212",
    "data-name": "Path 7212",
    d: "M377.809,19.309l2.81,3.01-3.5-.07-5.16-1.06-2.24,1.75,5.76,1.57-.14,1.17-11.47,3.63,4.84,4.66v7.85l-8.58-8.12.26-4.31,2.11-1.45-2.19-2.1-1.26-.13-.02,1.89-5.08-1.92-1.31,4.09-12.05-.09-1,7.21,5.84.09,6.03,6.85v5.85l-2.11,3.15-3.91.68v-7.22l-8.94-2.28-6.58-6.44h-6.38v.01h-.03l1.46,5.15v.01l-2.72.54h-7.31l-14.93-3.7-.01.01h-.01l-1.63,3.69-6.06-1.85-.02.01-4.52,3.43-3.67-2.14-21.48-7.58-8.46,1.91v.01h-.02v3.82h-14.98v.01h-.02v4.94l2.01,2.51V52.8l1.25,2.18-1.99-.49-4.63-2.1h-.02l-.8.17-.93.2-3.92-8.11.43-.96-1.11-.45-6.47-13.39,3.12-8.49-6.03,2.47-.03-.06,15.65-6.42,16.9-.46-2.1-4.78,4.37.34,2.47,8.09,2.74-2.83-3.17-3.93,14.49-6.48H287.8l1.1,3.93h17.81l3.28,2.46h7.88l2.74-2.46,9.73,1.59,1.57,2.13,27.9.8Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7213",
    "data-name": "Path 7213",
    d: "M370.649,145.969l6.64,9.35-.68,7.06-12.08,12.5-10.46-.6-1.28-7.06-3.57,1.53-3.4-2.97-20.67,4.52-1.28-1.53,1.7-4.09V152.6l10.89-5.1,8.08-8.93,4.42,1.96,1.96-4.08,7.4-.17-1.87,3.4,6.12,5.27,4.08-4.08v-5.7l1.88.59Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7214",
    "data-name": "Path 7214",
    d: "M374.489,121.459v9.17l-4.66-1.62,1.81-1.1-.98-2.79-5.44-2.27-2.2.08.42-2.05,3.73,1.47,3.53-2.87,3.79,1.97Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7215",
    "data-name": "Path 7215",
    d: "M365.009,118.209l.47,2.53-4.37-1.98Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7216",
    "data-name": "Path 7216",
    d: "M362.639,59.479l.2,4.83-3.69.94-.13,1.68-1.25.53-.43-2.12-5.5.81.41-1.41,4.6-1.19,3.4-3.09-.95-4.39,1.67.49Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7217",
    "data-name": "Path 7217",
    d: "M362.709,52.279l-1.06,1.82-2.5.03-.78,1.06-1.1-.65-.11-4.59Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7218",
    "data-name": "Path 7218",
    d: "M359.779,121.249v.92l-3.56.37.37-1.29Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7219",
    "data-name": "Path 7219",
    d: "M357.409,112.959l.59.72-.96,1.19.37,2.59-1.64-.4.45-2.92Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7220",
    "data-name": "Path 7220",
    d: "M354.369,44.329l2.83,4.02h-1.69l-2.28-4.25-4.66-5.75,1.64.05,5.8,5.93Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7221",
    "data-name": "Path 7221",
    d: "M356.589,66.529l-.96,1.74-1.27-1.44Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7222",
    "data-name": "Path 7222",
    d: "M355.349,129.839v.97l-2.6.31-.93-1.27v-.01Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7223",
    "data-name": "Path 7223",
    d: "M353.029,102.349l1.36,4.24-1.6.41.67,1.22-1.98.6v-1.9l-2.74-1.95h3.29Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7224",
    "data-name": "Path 7224",
    d: "M353.269,67.209l.65.96-.72,2.26-1.92-2.97Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7225",
    "data-name": "Path 7225",
    d: "M352.229,98.579l1.44,2.31h-1.51l-1.38-1.78Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7226",
    "data-name": "Path 7226",
    d: "M353.089,115.049l-1.74,2.06-1.17.1-2.36-.81-1.28,1.4.66.91,3.22-.13-2.02,1.69,1.07,2.35v1.48l-1.89-.66-.78-2.06-.93,1.03.48,2.78-1.58.48-.79-4.03,1.26-1.69-.15-3.11,2.18-1.97,3.29.8,1-.65Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7227",
    "data-name": "Path 7227",
    d: "M351.819,129.849l.93,1.27-1.44,1.29-1.61-.2Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7228",
    "data-name": "Path 7228",
    d: "M350.779,100.609l.78,1.36-.62.82-1.09-1.64Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7229",
    "data-name": "Path 7229",
    d: "M350.569,96.329l-.47,1.4-3.3-.42-2.82-3.39.49-4.25,1.99.04,1.09,2.41-1.1,2.52,1.1,1.37Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7230",
    "data-name": "Path 7230",
    d: "M349.139,101.979l.71,1.07-.71.85-.8-.99Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7231",
    "data-name": "Path 7231",
    d: "M349.139,99.869l-1.1,1.66-1-.68.64-1.16Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7232",
    "data-name": "Path 7232",
    d: "M349.009,62.309l-.45,3.06-2.66.19-2.19-4.75,1.62-1.5Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7233",
    "data-name": "Path 7233",
    d: "M348.909,130.119l-.85.69h-2.02l-.41-1.37h2.12Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7234",
    "data-name": "Path 7234",
    d: "M347.039,98.839l-.46.85-1.14-1.11.19-1.13Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7235",
    "data-name": "Path 7235",
    d: "M345.629,131.319l.51,1.1h-1.47l-.62-.76Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7236",
    "data-name": "Path 7236",
    d: "M345.439,53.509l.37,4.19-2.1.28,1.62,1.33-1.62,1.5-2.09-.59-1.58-2.99,2.13-1.47,3.26-2.25Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7237",
    "data-name": "Path 7237",
    d: "M345.439,53.5v.01h-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7238",
    "data-name": "Path 7238",
    d: "M345.439,46.289V53.5l-.01.01V46.3l-8.95-2.28-6.57-6.44h-6.37v-.01h6.38l6.58,6.44Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7239",
    "data-name": "Path 7239",
    d: "M282.439,54.7v-.01l-1.06-4.94,6.38-4.86,14.77,8.62,17.08.18,2.06-4.18,5.51-1.16.37-2.05v-.01l-3.84-.61-1.46-2.39v-.01l2.72-.54v-.01h.02l-1.45-5.15h6.37l6.57,6.44,8.95,2.28v7.21l-3.26,2.25-2.13,1.46v.01l-2.81,1.93-2.01-3.83-2.92,2.56,2.3,3.77,1.17-.76h3.66l-3.18,3.47,6.19,10.19-3.47,7.77-10.62,3.79-.06-1.74-1.8,1.02-.01-.01-4.23-3.62-4.62,2.34-1.86.94-3.7-6.16.95-2.6-2.14-.92h-.01l.01-.01-4.84-2.09-.01.01-3.27,3L299.6,75.2h-.01l-.82-.29-11.4-3.95v.01h-.01v-.01l-2.41-.83-.28-5.48-2.1-.96h-.01l-4.05-1.85-.63-.29-1.26-3.09-.57-1.39Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7240",
    "data-name": "Path 7240",
    d: "M344.719,100.539l.05,1.62-2.38,1.97-1.33-.26Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7241",
    "data-name": "Path 7241",
    d: "M343.619,79.439l1.12,1.17-1.12,3.14-1.83-1.71Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7242",
    "data-name": "Path 7242",
    d: "M343.069,110.359v7.62l-3.29,4.2h-6.65l-2.09-3.66-.13-3.68.04-.01,1.39.84,6.44-1.44,1.92-3.63Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7243",
    "data-name": "Path 7243",
    d: "M343.069,110.349v.01l-2.37.24Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7244",
    "data-name": "Path 7244",
    d: "M343.069,107.569v2.78l-2.37.25-1.92,3.63-6.44,1.44-1.39-.84,6.76-3.12,2.92-3.94Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7245",
    "data-name": "Path 7245",
    d: "M342.169,55.759l-2.13,1.47v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7246",
    "data-name": "Path 7246",
    d: "M338.989,129.439l.2.95-13.7-2.32,2.06-1.65,3.42,1.3,3.08-.68Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7247",
    "data-name": "Path 7247",
    d: "M330.419,87.449v1.24l-1.3,1.62-.89-1.08v-1.29Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7248",
    "data-name": "Path 7248",
    d: "M329.739,95.469l.18,5.16-5.25,3.47-.07-2.95,2.74-2.05v-4.41l-5.06-5.39-1.13-3.47-3.52-1.72,4.62-2.34,4.23,3.62-1.95,1.11-.27,3.17Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7249",
    "data-name": "Path 7249",
    d: "M327.549,46.289v.01l-3.84-.62Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7250",
    "data-name": "Path 7250",
    d: "M327.549,46.3l-.37,2.05-5.52,1.15-2.05,4.19-17.08-.19-14.76-8.62,4.51-3.44,6.07,1.85.01-.01h.01l1.63-3.69,14.93,3.7h7.32l1.46,2.39Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7251",
    "data-name": "Path 7251",
    d: "M327.339,96.019V99.1l-2.74,2.05-1.85.26-1.64-1.63v-2.73l1.03-1.03Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7252",
    "data-name": "Path 7252",
    d: "M327.339,94.689v1.33h-5.2l2.32-2.33-2.48-3.38h-4.39v-2.75h-.01l-1.81-1.06v-1.45l1.86-.94,3.52,1.72,1.12,3.47Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7253",
    "data-name": "Path 7253",
    d: "M326.179,121.629v2.81l-2.01,1.67-12.7-17.29,3.75,1.43Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7254",
    "data-name": "Path 7254",
    d: "M320.069,107.5l4.56,6.73-.38,1.47-4.83-4.12-1.17-3.81,1.81-.27Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7255",
    "data-name": "Path 7255",
    d: "M321.979,90.309l2.48,3.38-2.32,2.33-1.03,1.03v2.73l-3.29-3.26-.68,6.67,2.92,4.31-1.81.27h-.01l-.29-.93-3.01-2.56.1-1.68.01-.02v.02l1.72-3.38-3.1-11.19,2.09-1.53h.01l1.81,1.06v2.75h4.4Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7256",
    "data-name": "Path 7256",
    d: "M322.249,43.279v.01h-7.32L300,39.589l.01-.01,14.93,3.7Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4743",
    "data-name": "Rectangle 4743",
    width: 0.01,
    height: 2.75,
    transform: "translate(1519.579 743.559)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7257",
    "data-name": "Path 7257",
    d: "M313.669,88.029l3.1,11.19-1.72,3.36.26-4.25L314.2,94.2l-2.01-2.26-1.08,1.35-1.51-.45-.81-4.27-2.14-1.79.31-2.12v-.01l1.05-7.22,2.86-2.06h.01l2.14.92-.96,2.6,3.7,6.16V86.5l-2.09,1.52Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7258",
    "data-name": "Path 7258",
    d: "M316.769,99.219l-1.72,3.38v-.02Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4744",
    "data-name": "Rectangle 4744",
    width: 0.01,
    height: 1.45,
    transform: "translate(1517.759 741.049)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7259",
    "data-name": "Path 7259",
    d: "M312.069,78.889l3.7,6.16h-.01l-3.7-6.16.96-2.6Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7260",
    "data-name": "Path 7260",
    d: "M315.759,86.5l-2.09,1.53v-.01Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7261",
    "data-name": "Path 7261",
    d: "M310.879,75.359l-.01.01-4.84-2.09.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7262",
    "data-name": "Path 7262",
    d: "M306.029,73.279l4.84,2.09-2.86,2.06-.01.01-1.04,7.21-2.49-2.33-.41-2.79-1.99.82-1.71-2.28.18-.74,1.53.38.68-1.42.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7263",
    "data-name": "Path 7263",
    d: "M308,77.439l.01-.01-1.05,7.22Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7264",
    "data-name": "Path 7264",
    d: "M306.959,84.659l-.31,2.12-4.74-3.98-1.07,1.03-1.65-5.21,1.17-.55,1.71,2.28,1.99-.82.41,2.79Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7265",
    "data-name": "Path 7265",
    d: "M302.759,76.279l-.01.01L299.6,75.2Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7266",
    "data-name": "Path 7266",
    d: "M302.749,76.289l-.68,1.42-1.53-.38L299.2,77l.4-1.8Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7267",
    "data-name": "Path 7267",
    d: "M299.189,78.619l1.65,5.21-10.01,9.67-.68,7.99-4.39,2.7-6.91-19.88L278,84.3l-.38,1.78-2.16-.25-1.2-1.56,1.27-1.3-2.71-.86-.27-.32,3.27-.88v-2.24l-1.82-.68.01-2.58h2.43l3.8-3.5V71.9l-.84-3.41v-.01l-1.75-.99.08-1.75,2.89-2.05h1.95l2.1.96.27,5.48h.01l2.41.84-.02,3.08,9.67,3.66,1.76-2.8.82.29-.4,1.8h.01l1.34.33-.18.74-1.17.54Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7268",
    "data-name": "Path 7268",
    d: "M298.769,74.909l-1.76,2.8-9.67-3.66.03-3.08Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7269",
    "data-name": "Path 7269",
    d: "M298.769,74.909l-11.4-3.94v-.01Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7270",
    "data-name": "Path 7270",
    d: "M298.359,43.279l-.01.01-6.07-1.85.02-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7271",
    "data-name": "Path 7271",
    d: "M287.759,44.879v.01l-6.38,4.86-.01.01,1.07,4.93-4.09-1.89-.01-.01-6.4.28-2.71,2.23-2.77.12-2.88-3.79-3.93.75-4.7-3.22-3.56.83.4,5.01-2.31-1.93-2.61.72-2.05-1.7.09-2.24,3.11-1.51-2.56-1.73-4.3,1.73-2.01-2.51V40.9h14.98v-.01h.02v-3.83l8.44-1.89,21.47,7.57,3.68,2.15Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7272",
    "data-name": "Path 7272",
    d: "M287.759,44.869v.01l-.02.01-3.68-2.15-21.47-7.57-8.44,1.89,8.46-1.91,21.48,7.58Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7273",
    "data-name": "Path 7273",
    d: "M287.359,70.959v.01l-2.41-.84Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7274",
    "data-name": "Path 7274",
    d: "M284.669,64.649l.28,5.48h-.01Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7275",
    "data-name": "Path 7275",
    d: "M282.559,63.689h-1.94l-2.89,2.05-.08,1.75,1.75,1,.84,3.41-3.8,3.5H274v2.59l1.82.69v2.23l-3.28.87-1.97-2.24h-7.49l1.73-2.97-1.91-2.4-.33-.93-.1-.28,5.36.05,4.99-4.61v-.01l1.37-5.93,4.32-.62Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7276",
    "data-name": "Path 7276",
    d: "M281.379,49.749l1.06,4.94-1.07-4.93Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7277",
    "data-name": "Path 7277",
    d: "M282.439,54.689v.01l-6.39,2.37h-.01l.57,1.39-3.66.35-3.44-1.12,2.75-.79h.01l.23-1.74h-.02l-3.24.15,2.7-2.23,6.41-.28Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7278",
    "data-name": "Path 7278",
    d: "M280.239,71.9v.01l-3.8,3.5h-2.43l-.01,2.58V75.4h2.44Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7279",
    "data-name": "Path 7279",
    d: "M278.509,61.839l-4.32.62-.88-2.5-3.83,1.97-1.31-3.85,1.34-.39,3.44,1.12,3.66-.35,1.26,3.09h.01Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7280",
    "data-name": "Path 7280",
    d: "M276.619,58.459l1.26,3.09h-.01l-1.26-3.09Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7281",
    "data-name": "Path 7281",
    d: "M276.049,57.069l.57,1.39h-.01l-.57-1.39Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7282",
    "data-name": "Path 7282",
    d: "M275.819,78.669v.01l-1.82-.69Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7283",
    "data-name": "Path 7283",
    d: "M275.819,80.909l-3.27.88h-.01v-.01Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7284",
    "data-name": "Path 7284",
    d: "M273.309,59.959l.88,2.5-1.37,5.93-4.99,4.62-5.36-.05-2.31-6.73,1.09-2.33,5.34-2.74h.01l2.87.77h.01Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7285",
    "data-name": "Path 7285",
    d: "M272.819,68.389v.01l-4.99,4.61Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7286",
    "data-name": "Path 7286",
    d: "M272.479,55.159l-.22,1.74-2.75.79-1.34.39h-.01l1.31,3.85-2.87-.77h-.01l-8.8-7.05h-3.73l-2.27.9V55l-.4-5.01,3.56-.82,4.7,3.22,3.92-.75,2.88,3.79,2.78-.12h.01Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7287",
    "data-name": "Path 7287",
    d: "M266.589,61.159l-5.34,2.74-.55-.89-.88-1.44h-.01l-5.61-1.78-3.32,1.1.15-3.64-4.16-3.45,2.61-.72,2.31,1.93,2.27-.9h3.73Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7288",
    "data-name": "Path 7288",
    d: "M262.889,74.169l1.92,2.4-1.73,2.97H260.7l-8.58-2.56-4.66-4.87-2.01-.19-6.76-11.47V58.8l.99-.1,1.92-.18,2.66-.27,2.33,4.11h4.23l.06-1.47,3.32-1.1,5.61,1.78.89,1.44.55.89-1.1,2.32.01.01,2.31,6.73.1.28Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7289",
    "data-name": "Path 7289",
    d: "M261.289,83.639l-6.97,8.64-2.11-1.43v-2.27l3.79-1.02v-3.92l-1.7-.24,3.13-3.19Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7290",
    "data-name": "Path 7290",
    d: "M257.429,80.209,254.3,83.4l-.81-.11-1.42-.2-1.19-2.19,2.86.57,2.26-2.54Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7291",
    "data-name": "Path 7291",
    d: "M256,83.639v3.92l-3.79,1.02-3.74,1-5.35,2.8.35-1.43-3.78-.48-1.1,1.9-.22-.69-10.64-18.49,1.14.14,1.72-.8.53-3.08,1.33-.57.09.05,8.07,4.21,1.39.01h1.19l.94,1.22v.01h1.32l3.02,4.93.37.24,1.16.77.88.58,1.19,2.19,1.42.2.8.12Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7292",
    "data-name": "Path 7292",
    d: "M256,83.639l-1.71-.23.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7293",
    "data-name": "Path 7293",
    d: "M254.319,92.289l-13.85,6.24-1.88-6.16,1.1-1.9,3.78.48-.35,1.43v.01l5.35-2.81,3.74-1v2.27Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7294",
    "data-name": "Path 7294",
    d: "M254.3,83.4l-.01.01-.8-.12Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4745",
    "data-name": "Rectangle 4745",
    width: 14.98,
    height: 0.01,
    transform: "translate(1441.149 696.889)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7295",
    "data-name": "Path 7295",
    d: "M250.789,99.879l.6,3.01-14.75,17.16v-6.82l2.73-2.28h.01l6.67-5.56-6.03-2.14-1.51-1.7,1.49-1.07.54.92Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7296",
    "data-name": "Path 7296",
    d: "M249.429,77.669l1.33,1.87-.76.78-1.16-.77Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7297",
    "data-name": "Path 7297",
    d: "M249.879,136.3l-5.89,18.9-3.47-.15-1.44-3.42,1.17-3.29.68-4.93,6.85-7.11Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7298",
    "data-name": "Path 7298",
    d: "M246.049,105.389l-6.67,5.56h-8.03l-.91-.95-.01-.01-4.71-4.93,4.07-9.62h5.76l2.34,3.7-.89.74,3.02,3.37Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7299",
    "data-name": "Path 7299",
    d: "M243.849,71.769l1.6,2.6h-1.32l-.93-1.22H242l.34-1.38Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7300",
    "data-name": "Path 7300",
    d: "M238.649,60.459l6.66,11.3-2.97.01-.34,1.38-1.39-.01-8.07-4.21-.02-.08-.39-1.63,2.23-1.34,1.22-4.8Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7301",
    "data-name": "Path 7301",
    d: "M242.409,54.989l1.85,3.26-2.67.26-2.44-2.23,1.25-1.79,1.99.5Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7302",
    "data-name": "Path 7302",
    d: "M244.259,58.249l-2.66.27-.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7303",
    "data-name": "Path 7303",
    d: "M242.389,54.979v.01l-1.99-.5Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7304",
    "data-name": "Path 7304",
    d: "M241.6,58.519l-1.92.18,1.91-.19Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7305",
    "data-name": "Path 7305",
    d: "M241.589,58.509l-1.91.19-.99.1-1.17-2.52h1.63Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7306",
    "data-name": "Path 7306",
    d: "M240.4,54.489l-1.25,1.79h-1.63l-.05-.01-3.58-.91v-2.57l.08-.01.07.02-.02-.03.93-.21.8-.17h.01l4.62,2.1Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7307",
    "data-name": "Path 7307",
    d: "M240.4,54.489h-.02l-4.62-2.1h.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7308",
    "data-name": "Path 7308",
    d: "M239.269,99.229l.73,1.25-1.49,1.07L237,99.879l.89-.74.89-.75Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7309",
    "data-name": "Path 7309",
    d: "M239.369,110.949l-2.73,2.28h-.01v6.82l-2.48,2.9-7.07-4.67,1.16-2.03v-.01l.36-2.7-.74-3.18,2.58-.36.91.95Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7310",
    "data-name": "Path 7310",
    d: "M232.849,88.209l5.93,10.18-.89.75-2.34-3.7h-5.76v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7311",
    "data-name": "Path 7311",
    d: "M238.649,58.8v1.65l-3.07.62-2.7.55-4.75.97L217.419,62l-2.33-4.68,2.83.02.5-.59.76-.91,14.66-.48,3.63.92Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7312",
    "data-name": "Path 7312",
    d: "M235.069,133.2l.75,7.11-7.6,6.24.24,6.81-3.24,2.26-.1.76-1.56.03V150.8l2.16-5.05v-3.16l-3.46-2.26,3.46-2.41.05-.03,1.83,1.5v3.2l1.83-1.6v-2.74l-1.93-1.28v-2.2h.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7313",
    "data-name": "Path 7313",
    d: "M235.579,61.069v.01l-2.7.54Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7314",
    "data-name": "Path 7314",
    d: "M235.579,61.079l-1.22,4.8-2.23,1.33-2.75,1.64-1.65-1.15,1.24-2.3-1.35-.47.5-2.33,4.76-.98Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7315",
    "data-name": "Path 7315",
    d: "M234.149,122.949l.93,10.25h-.01l-7.56,1.57v-3.73h-1.79l-1.05-1.47-3.68-5.19,1.55-3.83,1.05-2.62h1.16l-.66,1.13h2.55l.44-.77Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7316",
    "data-name": "Path 7316",
    d: "M234.949,52.559l-.93.21v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7317",
    "data-name": "Path 7317",
    d: "M234.149,122.949l-7.07-4.66v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7318",
    "data-name": "Path 7318",
    d: "M234.019,52.769l.02.03-.07-.02Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7319",
    "data-name": "Path 7319",
    d: "M234.019,52.759v.01l-.05.01v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7320",
    "data-name": "Path 7320",
    d: "M230.1,44.649l3.92,8.11-.05.01-5.38-1.88-.27-2.4,1.51-.41-.62-1.46v-.01h.02Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7321",
    "data-name": "Path 7321",
    d: "M233.969,52.769v.01l-.08.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7322",
    "data-name": "Path 7322",
    d: "M233.969,52.769l-.08.02v.01h-.02l-5.45-1.91-.27-2.4,1.51-.41-.61-1.43.16-.03.62,1.46-1.51.41.27,2.4Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7323",
    "data-name": "Path 7323",
    d: "M229.319,82.129l3.53,6.07v.01l-3.06,7.22v.01l-4.08,9.61.01.01,4.71,4.93-7.44,1.05-4.2-1.53-.01-.01h.02l-7.84-9v-5.11l2.21-2.18V93.2l.22-4.96.2-4.6h13.1Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7324",
    "data-name": "Path 7324",
    d: "M232.129,67.219l.39,1.63-.07.03-1.33.57h-.01l-.52,3.08-1.72.8-1.14-.14V67.7l1.65,1.15,2.75-1.64Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7325",
    "data-name": "Path 7325",
    d: "M231.119,69.449l-.53,3.08.52-3.08Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7326",
    "data-name": "Path 7326",
    d: "M230.529,43.689l-.43.96-.01-.02.42-.94-1.09-.44v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7327",
    "data-name": "Path 7327",
    d: "M230.509,43.689l-.42.94-.08-.16.35-.78-.89-.36-.01-.01-.04-.07Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7328",
    "data-name": "Path 7328",
    d: "M230.359,43.689l-.35.78-.01-.02.34-.76-.87-.36Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7329",
    "data-name": "Path 7329",
    d: "M230.339,43.689l-.34.76-.53-1.12Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7330",
    "data-name": "Path 7330",
    d: "M230.1,44.649l-.87,1.96h-.02l.88-1.98Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7331",
    "data-name": "Path 7331",
    d: "M230.089,44.629l-.88,1.98v.01l-.16.03-.01-.03v-.01h.02l.95-2.14Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7332",
    "data-name": "Path 7332",
    d: "M230,44.449l.01.02-.95,2.14h-.02Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7333",
    "data-name": "Path 7333",
    d: "M229.469,43.329l.53,1.12-.96,2.16v.01l-5.08,1.08,1.93,2.47-1.89.15-1.49-.84,1.09-1.13h-5.09l-.32.98-1.07-.44-.04-.02,1.44-2.26-.8-1.51h-.03l-.01-.01h-7.43l-.01.01h-.82v-1.55l2.2-2.74-.37-1.03,5.96.95.07-.01.09.01,3.71-.81Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7334",
    "data-name": "Path 7334",
    d: "M229.469,43.329l-8.39-3.41.01-.01,8.37,3.41Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7335",
    "data-name": "Path 7335",
    d: "M229.419,43.249l.04.07-8.37-3.41.09-.02h.01l8.23,3.35Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7336",
    "data-name": "Path 7336",
    d: "M229.429,138.249v2.74l-1.83,1.6v-3.21l-1.83-1.5-.05.04v-6.88h1.78v5.93Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7337",
    "data-name": "Path 7337",
    d: "M222.949,29.849l6.47,13.39-8.22-3.35h-.01l-2.27-.93,1.2-.77.17-.1-2.37-3.85h-3.08l-.37-2.6-.41-2.96-.02.02v-.02l.65-.6h.01l2.6-3.01.06-.07.01-.01-4.43-9.91,2.29-.12,11.48,3.67-2.9,1.44-5.86-.21v.01l-.17-.01,2.08,3.97.15-.06.03.06,6.03-2.47Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7338",
    "data-name": "Path 7338",
    d: "M229.419,43.239l-8.23-3.35h.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7339",
    "data-name": "Path 7339",
    d: "M223.9,72.8l5.42,9.33-2.63,1.5H213.6l.64-14.47v-.01l11.94,1.63,1.52,2.48-.03.07-.8,1.89Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7340",
    "data-name": "Path 7340",
    d: "M229.039,46.619l.01.03-4.92,1.05,1.93,2.47-2.04.16-.02-.01,1.89-.15-1.93-2.47Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7341",
    "data-name": "Path 7341",
    d: "M228.969,65.4l-1.24,2.3-.6-.44.49-2.33Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7342",
    "data-name": "Path 7342",
    d: "M228.6,113.539l-.36,2.7h-2.52l-.97,1.69h-3.4l1.64-6.89,4.87-.68Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7343",
    "data-name": "Path 7343",
    d: "M227.729,73.179v.01l-.03.07-1.52-2.48.95-3.51.6.43Z",
    transform: "translate(1202 656)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7344",
    "data-name": "Path 7344",
    d: "M227.6,139.379v.01l-1.83-1.5-.05.03.05-.04Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7345",
    "data-name": "Path 7345",
    d: "M226.879,18.619l-2.93,1.46-.14-.01,2.9-1.44-11.48-3.67.15-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7346",
    "data-name": "Path 7346",
    d: "M225.769,63.789l-.87,1.68-2.18-.55Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7347",
    "data-name": "Path 7347",
    d: "M225.719,142.589v3.16l-2.16,5.05h-3.92L218,148.5l-2.42-3.41-.98-1.36h2.77l4.89-3.4Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7348",
    "data-name": "Path 7348",
    d: "M225.719,131.039v6.88l-3.46,2.41-4.89,3.4h-4.82l-2.58-3.2v-3.56h3.15l-.1-3.97,8.05,3.97.96-1.92h-.01l-2.73-1.1.82-3.69,4.56-.69Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7349",
    "data-name": "Path 7349",
    d: "M225.119,156.409l-.38,2.59-8.29,9.6h-10.77l-3.28-8.99h5.66v-5.17l2.28,2.63,9.3-6.23h3.92v5.04h-1.53v1.43l1.53.92v-1.8Zm-5.01,5.38v-1.62h-1.64l-1.56,1v1.86h2.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7350",
    "data-name": "Path 7350",
    d: "M220.989,124.379l3.68,5.19-4.56.68v.01l-.83,3.69h.01l2.73,1.1-.95,1.92-8.05-3.97-2.5-1.24v-4.55h-.01v-.01h-2.82l-.57,2.01-2.81.09-.17-.56-.56-1.96h-.01l-4.46.03h-.01l-.85-1.13,3.78-1.72v-.01l3.97-6.59.63-4.91v-.01h.01l.33-2.6.33-.01,11.49-.32,4.2,1.53-1.64,6.89-1.24,5.2.01.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7351",
    "data-name": "Path 7351",
    d: "M224,50.319l-.15.01-1.51-.85,1.09-1.13h.17l-1.09,1.13Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7352",
    "data-name": "Path 7352",
    d: "M223.809,20.069l-.03.02-5.83-.22v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7353",
    "data-name": "Path 7353",
    d: "M223.589,117.929l-1.05,2.62h-.01l-1.89.4.71-3.02Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7354",
    "data-name": "Path 7354",
    d: "M223.559,156.429v1.77l-1.53-.92v-1.37h1.53v.52Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4746",
    "data-name": "Rectangle 4746",
    width: 1.53,
    height: 0.03,
    transform: "translate(1424.029 811.879)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7355",
    "data-name": "Path 7355",
    d: "M222.539,120.549l-1.55,3.83,1.54-3.83Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7356",
    "data-name": "Path 7356",
    d: "M222.529,120.549l-1.54,3.83-.87-1.24.52-2.19Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7357",
    "data-name": "Path 7357",
    d: "M218.919,38.959l2.27.93h-.01l-2.28-.92Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7358",
    "data-name": "Path 7358",
    d: "M221.179,39.889l-.09.02-.06-.02-2.27-.93,1.36-.87-2.37-3.85h.15l2.37,3.85-.15.1-1.2.77-.02.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7359",
    "data-name": "Path 7359",
    d: "M221.089,39.909l-.01.01-.06-.03h.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7360",
    "data-name": "Path 7360",
    d: "M221.079,39.919l-3.71.81-.09-.01v-.01h.02l.07.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7361",
    "data-name": "Path 7361",
    d: "M221.079,39.919l-3.71.8-.07-.01,3.05-.67.67-.15Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7362",
    "data-name": "Path 7362",
    d: "M218.759,38.959l2.27.93h-.02l-2.28-.92,1.37-.88-2.37-3.85h.02l2.37,3.85Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7363",
    "data-name": "Path 7363",
    d: "M221.019,39.889l-.67.15.66-.15Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7364",
    "data-name": "Path 7364",
    d: "M221.009,39.889l-.66.15-3.07.67-6.04-.96-.68-1.88,3.25-2.76,1.03-.87h2.89l2.37,3.85-1.37.88Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7365",
    "data-name": "Path 7365",
    d: "M220.349,40.039l-3.05.67h-.02Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7366",
    "data-name": "Path 7366",
    d: "M217.919,34.239l2.37,3.85-.17.1.15-.1-2.37-3.85Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7367",
    "data-name": "Path 7367",
    d: "M220.109,160.2v1.56l-1.19,1.24h-2.01v-1.8l1.56-1Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7368",
    "data-name": "Path 7368",
    d: "M220.109,160.169v.03h-1.64l-1.56,1v-.03l1.56-1Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7369",
    "data-name": "Path 7369",
    d: "M217.949,19.869l2.06,3.9-.15.06-2.08-3.97Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7370",
    "data-name": "Path 7370",
    d: "M219.639,150.8v.01l-9.3,6.23-2.28-2.63v-9.32h7.51L218,148.5Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7371",
    "data-name": "Path 7371",
    d: "M210.959,100.5l7.84,9h-.02Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7372",
    "data-name": "Path 7372",
    d: "M210.959,100.5l7.82,9-11.48.33-.33.01h-.01l-.33,2.6h-3.96l-2.55-3.6.91-3.65v-.01l1.96-.92Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7373",
    "data-name": "Path 7373",
    d: "M218.679,48.349l-.34,1.04-.15-.06.32-.98Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7374",
    "data-name": "Path 7374",
    d: "M217.719,45.1l.8,1.51-1.44,2.26-.03-.01v-.01l1.43-2.24-.79-1.51Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7375",
    "data-name": "Path 7375",
    d: "M217.689,45.1l.79,1.51-1.43,2.24-.03-.04-.03-.06v-.01l1.36-2.13-.8-1.51Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7376",
    "data-name": "Path 7376",
    d: "M217.549,45.1l.8,1.51-1.36,2.13-.02-.03V48.7l1.34-2.09-.79-1.51Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7377",
    "data-name": "Path 7377",
    d: "M217.519,45.1l.79,1.51-1.34,2.09-1.75-3.6Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7378",
    "data-name": "Path 7378",
    d: "M218.3,49.389l-.68,2.1-.16-.04.67-2.06-1.22-.52,1.26.52.02-.05Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7379",
    "data-name": "Path 7379",
    d: "M218.189,49.329v.01l-1.07-.45Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7380",
    "data-name": "Path 7380",
    d: "M218.189,49.339l-.02.05-1.26-.52.08-.12.03.06.02.05.01-.01v.01l.03.01.04.02Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7381",
    "data-name": "Path 7381",
    d: "M218.129,49.389l-.67,2.06-1.5-.42-.15.02-.02-.01-5.65.64-2.32-3.85,2.59-2.73h4.64l.03.06,1.79,3.7.01-.01v.01l.03.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7382",
    "data-name": "Path 7382",
    d: "M218,148.5l-2.43-3.41h.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7383",
    "data-name": "Path 7383",
    d: "M216.809,54.009l1.05,2.27h-.17l-1.03-2.22.12-.04h.02v-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7384",
    "data-name": "Path 7384",
    d: "M216.659,54.059l1.03,2.22h-2.44l-.03-1.75Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7385",
    "data-name": "Path 7385",
    d: "M217.689,45.1h-.17l-.01-.01h.17Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7386",
    "data-name": "Path 7386",
    d: "M217.619,51.509l-.82,2.5-.02.01-.12.04-.02-.05h-.01l.82-2.5-1.61-.45h.03l1.58.43.01-.02Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7387",
    "data-name": "Path 7387",
    d: "M217.519,45.1h-2.3v-.01h2.29Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7388",
    "data-name": "Path 7388",
    d: "M217.459,51.449v.02l-1.5-.42-.09.01-.06-.01.15-.02Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7389",
    "data-name": "Path 7389",
    d: "M215.959,51.049l1.5.42-.01.02-1.58-.43Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7390",
    "data-name": "Path 7390",
    d: "M217.449,51.509l-.82,2.5-1.58.51-3.25,1.05-.86-1.99h.01l-.8-1.87,5.69-.65Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7391",
    "data-name": "Path 7391",
    d: "M212.939,15.079l4.43,9.91-.01.01-4.43-9.92Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7392",
    "data-name": "Path 7392",
    d: "M212.929,15.079l4.43,9.92-.06.07-2.61,3.01h-.16l2.66-3.08.01-.01-4.43-9.9Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7393",
    "data-name": "Path 7393",
    d: "M217.3,25.069l-2.6,3.01h-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7394",
    "data-name": "Path 7394",
    d: "M211.239,39.749l6.04.96h-.03Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7395",
    "data-name": "Path 7395",
    d: "M217.279,40.709v.01l-.07.01-5.96-.95,5.96.94.04-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7396",
    "data-name": "Path 7396",
    d: "M217.249,40.709l-.04.01-5.96-.94-.01-.03Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7397",
    "data-name": "Path 7397",
    d: "M212.769,15.089l4.43,9.9-.01.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7398",
    "data-name": "Path 7398",
    d: "M212.769,15.089l4.42,9.91-2.67,3.08h-4.57l-3.12-1.58,2.67-6.05h-.88l-.03-.06-.73-1.77-.75-1.84h3.35V15.2l2.3-.11Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7399",
    "data-name": "Path 7399",
    d: "M217.189,25l-2.66,3.08h-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7400",
    "data-name": "Path 7400",
    d: "M217.049,48.849l-.01.01-.02-.05Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7401",
    "data-name": "Path 7401",
    d: "M216.969,48.709l.02.03v.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7402",
    "data-name": "Path 7402",
    d: "M216.989,48.749l-.08.12-.03-.01v-.01l.09-.14Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7403",
    "data-name": "Path 7403",
    d: "M216.969,48.7v.01l-.09.14-1.8-3.69-.03-.06h.17Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7404",
    "data-name": "Path 7404",
    d: "M216.879,48.849l-.01.01-1.79-3.7Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7405",
    "data-name": "Path 7405",
    d: "M216.8,54.009v.01h-.02Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7406",
    "data-name": "Path 7406",
    d: "M216.659,54.059l-1.44.47v-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7407",
    "data-name": "Path 7407",
    d: "M216.639,54.009l.02.05-1.44.46-.17.05v-.04l1.58-.51v-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7408",
    "data-name": "Path 7408",
    d: "M216.629,54.009v.01l-1.58.51v-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7409",
    "data-name": "Path 7409",
    d: "M215.839,51.059l-5.69.65V51.7l5.43-.63.23-.02Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7410",
    "data-name": "Path 7410",
    d: "M215.789,51.039l.02.01-.23.02-5.44.62v-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7411",
    "data-name": "Path 7411",
    d: "M214.6,143.729l.98,1.36h-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7412",
    "data-name": "Path 7412",
    d: "M215.579,51.069l-5.43.63-.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7413",
    "data-name": "Path 7413",
    d: "M214.6,143.729l.97,1.36h-7.51v14.49H202.4l-5.63-15.85H214.6Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7414",
    "data-name": "Path 7414",
    d: "M215.219,54.529l.03,1.75h-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7415",
    "data-name": "Path 7415",
    d: "M215.219,54.529l.02,1.75h-.16l-.03-1.69Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7416",
    "data-name": "Path 7416",
    d: "M215.209,14.949l.02.01-2.29.12h-.01l-.16.01v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4747",
    "data-name": "Rectangle 4747",
    width: 0.17,
    height: 0.01,
    transform: "translate(1417.049 701.089)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7417",
    "data-name": "Path 7417",
    d: "M215.219,54.519v.01l-.17.06v-.02Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7418",
    "data-name": "Path 7418",
    d: "M215.049,54.589l.03,1.69h-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7419",
    "data-name": "Path 7419",
    d: "M215.049,54.589l.02,1.69h-2.16l-2.62,1.29,1.32,2.88-1.1,1.75-1.79-2.25,1.42-.6-2.33-.65-1.21-1.39h.01l.69-.22.72-.23v-.01l.15-.05,3.65-1.17Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7420",
    "data-name": "Path 7420",
    d: "M215.049,54.569v.02l-3.23,1.04v-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7421",
    "data-name": "Path 7421",
    d: "M215.049,45.089v.01h-4.64l.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7422",
    "data-name": "Path 7422",
    d: "M215.049,54.529v.04l-3.23,1.05-.02-.04Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7423",
    "data-name": "Path 7423",
    d: "M215.049,54.519v.01l-3.25,1.05v-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7424",
    "data-name": "Path 7424",
    d: "M214.469,31.639l.37,2.6h-.02l-.36-2.6Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7425",
    "data-name": "Path 7425",
    d: "M214.839,34.239l-1.03.87-.1-.05.96-.82h.17Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7426",
    "data-name": "Path 7426",
    d: "M214.459,31.639l.36,2.6h-.15l-.36-2.55Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7427",
    "data-name": "Path 7427",
    d: "M214.689,28.079l-.65.6v.02l-.13.12-.02-.14-.02.02v-.02l.65-.6h.17Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7428",
    "data-name": "Path 7428",
    d: "M214.309,31.689l.36,2.55h-.02l-.35-2.55Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7429",
    "data-name": "Path 7429",
    d: "M214.669,34.239l-.96.82h-.01l-2.53-1.16-3.67-.94-.01-1.52,2.53,1.15.02-.07.15.07.27-1.23-.25-.18.85-.2,1.9,1.07.11-.03.06.03,1.17-.36.35,2.55Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7430",
    "data-name": "Path 7430",
    d: "M214.059,28.679l.41,2.96h-.01l-.42-2.94Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7431",
    "data-name": "Path 7431",
    d: "M214.039,28.7l.42,2.94-.15.05-.01-.05h.01l-.4-2.82Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7432",
    "data-name": "Path 7432",
    d: "M213.909,28.819l.4,2.82h-.02l-.4-2.8Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7433",
    "data-name": "Path 7433",
    d: "M214.3,31.639l.01.05h-.01l-.01-.04v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7434",
    "data-name": "Path 7434",
    d: "M214.289,31.649l.01.04-1.17.35-.05-.03Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7435",
    "data-name": "Path 7435",
    d: "M214.3,31.689l-1.17.36-.06-.03.01-.01.05.03Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7436",
    "data-name": "Path 7436",
    d: "M214.289,31.639v.01l-1.21.36Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7437",
    "data-name": "Path 7437",
    d: "M213.889,28.839l.4,2.8-1.21.37h-.01l-1.9-1.06-.11.03-.05-.03-.84.2-1.11-.85.32-.82,3.75-.08h.16Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7438",
    "data-name": "Path 7438",
    d: "M214.239,69.159l-.64,14.47-.01.01-.2,4.6-8.62-5.53h-9.16l-2.35-11.28,3.62-3.88v-.01l3.88.93,1.81,2.2,4.57.91,2.08-3.1Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7439",
    "data-name": "Path 7439",
    d: "M213.889,28.679l.02.14-.02.02-.02-.14Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7440",
    "data-name": "Path 7440",
    d: "M213.869,28.7l.02.14-.6.56h-.16Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7441",
    "data-name": "Path 7441",
    d: "M213.809,35.109l-3.25,2.76-.04-.1,3.13-2.66.05-.05h.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7442",
    "data-name": "Path 7442",
    d: "M213.7,35.059l-.05.05-2.64-1.21L207.5,33v-.04l3.67.94Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7443",
    "data-name": "Path 7443",
    d: "M213.649,35.109l-3.13,2.66-.4-1.14-.56-1.16-2.05-.68L207.5,33l3.51.9Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7444",
    "data-name": "Path 7444",
    d: "M213.389,88.239l-.22,4.96-2.21,2.18v5.11l-7.97,3.77-1.96.92-1-2.95h2l-2.47-5.26,2.99-6.16-1.18-8.1h3.4Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7445",
    "data-name": "Path 7445",
    d: "M213.169,93.2v.01l-2.21,2.18v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7446",
    "data-name": "Path 7446",
    d: "M213.019,133l.1,3.97h-3.15v3.56l2.58,3.2h-15.77l-.23-2.74,2.56-4.2v-9.98l4.46-.03.57,1.96.17.56v.01l2.81-.1h.01l.57-2h2.81v4.55h.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7447",
    "data-name": "Path 7447",
    d: "M213.079,32.009l-.01.01v-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7448",
    "data-name": "Path 7448",
    d: "M213.079,56.279l-2.62,1.29,1.32,2.88-1.18,1.87-.09-.12,1.1-1.75-1.32-2.88,2.62-1.29Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7449",
    "data-name": "Path 7449",
    d: "M211.169,30.949l1.9,1.06h-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7450",
    "data-name": "Path 7450",
    d: "M213.069,32.009v.01l-.11.03-1.9-1.07,1.9,1.06.1-.03Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7451",
    "data-name": "Path 7451",
    d: "M213.059,32.009l-.1.03-1.9-1.06.11-.03Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4748",
    "data-name": "Rectangle 4748",
    width: 0.01,
    height: 0.01,
    transform: "translate(1414.759 671.079)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7452",
    "data-name": "Path 7452",
    d: "M212.759,15.079v.01l-2.3.11v.01l-.17.01V15.2Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7453",
    "data-name": "Path 7453",
    d: "M211.819,55.619v.01l-3.65,1.17Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7454",
    "data-name": "Path 7454",
    d: "M211.819,55.619l-3.65,1.18-.15.05V56.8l3.63-1.17.15-.05Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7455",
    "data-name": "Path 7455",
    d: "M211.8,55.569v.01l-.15.05v-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7456",
    "data-name": "Path 7456",
    d: "M211.8,55.569l-.15.05-.86-2.01.15-.03Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7457",
    "data-name": "Path 7457",
    d: "M211.649,55.619v.01l-3.63,1.17Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7458",
    "data-name": "Path 7458",
    d: "M211.649,55.619l-3.63,1.18-.02-.15-.18-2.45v-.01l2.96-.58h.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7459",
    "data-name": "Path 7459",
    d: "M211.249,39.779l.37,1.03-2.2,2.74V45.1h-.04v-.65h.01v-.9l2.19-2.74-.37-1.04Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7460",
    "data-name": "Path 7460",
    d: "M211.209,39.769l.37,1.04-2.19,2.74-.12-.01,2.19-2.73-.38-1.06Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7461",
    "data-name": "Path 7461",
    d: "M211.079,39.749l.38,1.06-2.19,2.73-.03-.01,2.17-2.72-.38-1.06-.68-1.88-.44-1.23v-.01h-.01l-.01-.02h.05l.01.02.45,1.24Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7462",
    "data-name": "Path 7462",
    d: "M211.029,39.749l.38,1.06-2.17,2.72-5.12-.62-.22-.09h-.01l-3.7-1.46-.35-4.73h.35l3.8-.93.58.54.16-.01.01.01,2.57-.08,2.6.48.44,1.23Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7463",
    "data-name": "Path 7463",
    d: "M211.239,39.749l.01.03-.04-.01-.01-.02-.68-1.88-.03-.08.03-.02.04.1Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7464",
    "data-name": "Path 7464",
    d: "M211.2,39.749l.01.02-.13-.02-.68-1.88.09-.08.03.08Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7465",
    "data-name": "Path 7465",
    d: "M211.059,30.979l-.85.2-.04-.03.84-.2Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7466",
    "data-name": "Path 7466",
    d: "M210.959,100.489v.01l-7.97,3.76Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7467",
    "data-name": "Path 7467",
    d: "M210.149,51.709l.8,1.87h-.01l-.8-1.87Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7468",
    "data-name": "Path 7468",
    d: "M210.139,51.709l.8,1.87-.15.03h-.01l-.01-.03h.01l-.8-1.87.16-.02.01.01v.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7469",
    "data-name": "Path 7469",
    d: "M210.769,53.579l.01.03-2.96.58-.02-.03Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7470",
    "data-name": "Path 7470",
    d: "M209.979,51.709l.8,1.87h-.01l-.8-1.87Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7471",
    "data-name": "Path 7471",
    d: "M209.969,51.709l.8,1.87-2.97.58h-.01l-.8-1.12-.68-.94v-.01l-.51-2.84v-.01l-.19-1.02v-.01l2.06-.35,2.31,3.84v.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7472",
    "data-name": "Path 7472",
    d: "M210.119,36.629l.4,1.14-.03.02-.41-1.15v-.01h-.01l-.55-1.15-2.05-.69v.04l-.13-.04-.01-1.83.17.04.01,1.79,2.05.68Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4749",
    "data-name": "Rectangle 4749",
    width: 0.01,
    height: 4.55,
    transform: "translate(1412.509 783.209)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7473",
    "data-name": "Path 7473",
    d: "M210.509,62.2l-.08.12-1.88-2.37,1.42-.6-2.33-.65-1.21-1.39h.01l.13-.04.04.04h-.01l1.21,1.39,2.33.65-1.42.6Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7474",
    "data-name": "Path 7474",
    d: "M210.079,36.639l.41,1.15-.09.08-.45-1.24-.01-.02Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7475",
    "data-name": "Path 7475",
    d: "M210.459,15.209v1.57h-.17v-1.56Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7476",
    "data-name": "Path 7476",
    d: "M210.459,31.359l-.27,1.23-.15-.07.25-1.16-.24-.18.12-.03.04.03Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7477",
    "data-name": "Path 7477",
    d: "M210.419,45.089l-.01.01h-.17l.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7478",
    "data-name": "Path 7478",
    d: "M210.409,45.1l-2.59,2.73h-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7479",
    "data-name": "Path 7479",
    d: "M210.409,45.1l-2.6,2.73-.14.03-.02-.03,2.59-2.73Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7480",
    "data-name": "Path 7480",
    d: "M210.289,15.219v1.56h-4.75l-8.6,6.3v5.6l-.21.32-.91,1.42-.24-.29-.15.02-.02-.02-4.87.79-1.66-3.89,16.71-11.57Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7481",
    "data-name": "Path 7481",
    d: "M210.289,15.209v.01l-4.7.24-16.71,11.57,1.66,3.89-.16.03-1.67-3.92,16.71-11.57Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7482",
    "data-name": "Path 7482",
    d: "M210.239,45.1l-2.59,2.73-2.18.38h-.03v.01l-.77.13-.19.03h-.02l-2.41-.9-.6-.22,2.11-1.74h.01l5.64-1.04v.62h1.03Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7483",
    "data-name": "Path 7483",
    d: "M210.169,31.149l-.12.03-1.16-.88.32-.82h.17l-.32.82Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7484",
    "data-name": "Path 7484",
    d: "M210.139,51.679v.01l-.16.02V51.7Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7485",
    "data-name": "Path 7485",
    d: "M210.139,51.679l-.16.02-2.31-3.84.14-.03h.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7486",
    "data-name": "Path 7486",
    d: "M210.079,36.629v.01l-.14-.03.13.02Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7487",
    "data-name": "Path 7487",
    d: "M209.519,35.479l.55,1.15-.13-.02V36.6l-.55-1.13-1.92-.64v-.04Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7488",
    "data-name": "Path 7488",
    d: "M210.039,32.519l-.02.07-2.53-1.15v-.08Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7489",
    "data-name": "Path 7489",
    d: "M209.949,28.079h-.17l-3.12-1.58,2.67-6.05h.17l-2.67,6.05Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7490",
    "data-name": "Path 7490",
    d: "M209.939,36.6v.01h-.05v-.02Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7491",
    "data-name": "Path 7491",
    d: "M209.939,36.6l-.05-.01-.54-1.11-1.88-.62v-.03l1.92.64Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7492",
    "data-name": "Path 7492",
    d: "M209.909,36.629v.01l-2.6-.48.03-.01,2.56.48Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7493",
    "data-name": "Path 7493",
    d: "M209.889,36.609l.01.02-2.56-.48h.14v.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7494",
    "data-name": "Path 7494",
    d: "M209.889,36.609l-2.41-.45v-.01l2.41.44Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7495",
    "data-name": "Path 7495",
    d: "M209.889,36.589l-2.41-.44-.01-1.29,1.88.62Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7496",
    "data-name": "Path 7496",
    d: "M209.389,43.549v.9h-.01l-.12.02v-.92l.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7497",
    "data-name": "Path 7497",
    d: "M209.379,44.449v.65h-.12v-.63Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7498",
    "data-name": "Path 7498",
    d: "M209.239,43.529l.03.01-.01.01v.92l-.05.01v-.03h.01v-.9Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7499",
    "data-name": "Path 7499",
    d: "M209.259,44.469v.63h-.05v-.62Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7500",
    "data-name": "Path 7500",
    d: "M209.239,43.529l-.02.02-5.27-.64h-.01l-.11-.05.06-.04h.01l.22.09Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7501",
    "data-name": "Path 7501",
    d: "M209.219,43.549v.9h-.01l-5.66,1.04h-.01l-1.53-1.46,1.81-1.16.12.04h.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7502",
    "data-name": "Path 7502",
    d: "M203.559,45.509l-.01-.02,5.66-1.04v.03l-5.64,1.04h-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7503",
    "data-name": "Path 7503",
    d: "M208.589,20.389l.03.06h-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7504",
    "data-name": "Path 7504",
    d: "M208.589,20.389l.02.06h-.16l-.76-1.83-.75-1.84h.16l.76,1.84Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7505",
    "data-name": "Path 7505",
    d: "M207.689,18.619l.76,1.83h-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7506",
    "data-name": "Path 7506",
    d: "M207.689,18.619l.75,1.83h-1.09l-5.56,6.07,2.47,3.07-5.17,4.58-3.17-3.64,1.19-1.85v-5.6l8.59-6.3h1.23Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7507",
    "data-name": "Path 7507",
    d: "M208.019,56.8v.05l-.72.24-.69.22-.04-.04,1.14-.37.14-.04v-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7508",
    "data-name": "Path 7508",
    d: "M208.019,56.849v.01l-.72.23Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7509",
    "data-name": "Path 7509",
    d: "M208,56.649l.02.15-.17.05-.02-.2-.18-2.45v-.01l.14-.03.02.03Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7510",
    "data-name": "Path 7510",
    d: "M208,56.649l-.19-2.46h.01v.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7511",
    "data-name": "Path 7511",
    d: "M207.109,16.779l.75,1.84-.76-1.84Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7512",
    "data-name": "Path 7512",
    d: "M207.829,56.649l.02.2-.14.05-1.14.37-.18-.2-.76-3.3,1.24-.66.77,1.08Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7513",
    "data-name": "Path 7513",
    d: "M207.849,56.849v.01l-.14.04Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7514",
    "data-name": "Path 7514",
    d: "M207.829,56.649l-.19-2.46h.01v.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7515",
    "data-name": "Path 7515",
    d: "M207.8,54.159l.02.03h-.01l-.02-.03Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7516",
    "data-name": "Path 7516",
    d: "M206.989,53.039l.8,1.12-.14.03-.78-1.08V53.1Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7517",
    "data-name": "Path 7517",
    d: "M206.939,16.779l.75,1.84-.76-1.84Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7518",
    "data-name": "Path 7518",
    d: "M207.649,47.829l.02.03-2.06.35-.16.03h-.01v-.03h.03l2.17-.37Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7519",
    "data-name": "Path 7519",
    d: "M206.869,53.109l.78,1.08h-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7520",
    "data-name": "Path 7520",
    d: "M207.649,47.829l-.01.01-2.17.37Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7521",
    "data-name": "Path 7521",
    d: "M207.519,20.449l-5.56,6.07,2.47,3.07-5.27,4.66-.07-.08,5.17-4.58-2.47-3.07,5.56-6.07Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7522",
    "data-name": "Path 7522",
    d: "M207.5,32.959V33l-.17-.04-.01-1.6.17.08Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7523",
    "data-name": "Path 7523",
    d: "M207.469,34.859l.01,1.29h-.17l-.01-1.35Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7524",
    "data-name": "Path 7524",
    d: "M207.339,36.149l-.03.01v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7525",
    "data-name": "Path 7525",
    d: "M207.309,36.149v.01l-2.57.08-.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7526",
    "data-name": "Path 7526",
    d: "M206.309,52.1l.68.94-.12.06-.05-.06-.61-.86Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7527",
    "data-name": "Path 7527",
    d: "M206.969,109.839l-.33,2.6h-.01l.33-2.6Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7528",
    "data-name": "Path 7528",
    d: "M206.869,53.1v.01l-1.24.66-.12-.03,1.31-.7Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7529",
    "data-name": "Path 7529",
    d: "M206.209,52.179l.61.86-.62-.86Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7530",
    "data-name": "Path 7530",
    d: "M206.2,52.179l.62.86-1.31.7-1.01-.25Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7531",
    "data-name": "Path 7531",
    d: "M206.629,112.449l-.63,4.91-3.97,6.59-3.78,1.73-1.55-2.07v-3.53h3.96l-2.02-6.53h3.67l.38-1.1Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7532",
    "data-name": "Path 7532",
    d: "M206.389,57.069l.18.2-.13.04-.22-.24-.76-3.3.05-.03.12.03Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7533",
    "data-name": "Path 7533",
    d: "M206.309,52.089v.01l-.1.08h-.01v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7534",
    "data-name": "Path 7534",
    d: "M205.8,49.249l.51,2.84-.11.08-.06-.07v-.01l-.5-2.82Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7535",
    "data-name": "Path 7535",
    d: "M206.2,52.169v.01l-.06-.08Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7536",
    "data-name": "Path 7536",
    d: "M206.2,52.179l-1.7,1.31,1.01.25-.05.03-1.13-.28.05-.04.11.03Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7537",
    "data-name": "Path 7537",
    d: "M206.2,52.179l-1.71,1.3-.11-.03,1.76-1.35Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7538",
    "data-name": "Path 7538",
    d: "M206.139,52.089v.01l-1.76,1.35h-.02Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7539",
    "data-name": "Path 7539",
    d: "M205.639,49.269l.5,2.82-.51-2.82Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7540",
    "data-name": "Path 7540",
    d: "M205.629,49.269l.51,2.82-1.78,1.36-.81-.2-1.62-3.48Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7541",
    "data-name": "Path 7541",
    d: "M205.8,49.239v.01l-.16.02h-.01v-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7542",
    "data-name": "Path 7542",
    d: "M205.8,49.239l-.17.02v-.02l-.18-.99.16-.03Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7543",
    "data-name": "Path 7543",
    d: "M205.7,16.779l-8.59,6.3v5.6l-1.19,1.85-.09-.11.9-1.42.21-.32v-5.6l8.6-6.3Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7544",
    "data-name": "Path 7544",
    d: "M205.629,49.259v.01l-3.7.5v-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7545",
    "data-name": "Path 7545",
    d: "M205.629,49.249v.01l-3.7.5v.01l1.62,3.48-.19-.05-1.57-3.38-.02-.05Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7546",
    "data-name": "Path 7546",
    d: "M205.629,49.239v.01l-3.86.52h-.01v-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7547",
    "data-name": "Path 7547",
    d: "M205.629,49.239l-3.87.52v.01l.03.05,1.57,3.38-.41-.1-2.88-3.33-.16.01-.01-.01-.43.03,1.77-.93.77-1.33,2.35.87.1-.02h.03l.04.02.92-.16Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7548",
    "data-name": "Path 7548",
    d: "M205.609,48.209v.01l-.16.03v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7549",
    "data-name": "Path 7549",
    d: "M205.449,48.249l-.92.16-.04-.02.04.01.91-.16Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7550",
    "data-name": "Path 7550",
    d: "M205.439,48.219v.02l-.91.16-.04-.01.18-.04Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7551",
    "data-name": "Path 7551",
    d: "M205.039,57.129l-1.55.32-.39,2.07-1.25.73-.01-.08,1.09-.64.39-2.08,1.55-.31-8.3-7.19,2.35-.14-.66-1.24.68,1.25-2.2.13Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7552",
    "data-name": "Path 7552",
    d: "M204.869,57.139l-1.55.31-.39,2.08-1.09.64-.34-2.81-6.8-6.79h-2.21l-1.89-.87.02-.11.26-1.28.01-.03,1.72.12.04-.01.13.01,1.34-.31.37-.08V48l3.08-.71.69,1.28.66,1.24-2.35.14Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7553",
    "data-name": "Path 7553",
    d: "M204.729,36.229l-.16.01-.58-.54.13-.03Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7554",
    "data-name": "Path 7554",
    d: "M204.669,48.349l-.18.04-.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7555",
    "data-name": "Path 7555",
    d: "M202.049,47.479l2.41.9-2.42-.89Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7556",
    "data-name": "Path 7556",
    d: "M204.459,48.379v.01l-.1.02-2.35-.87.01-.01,2.34.87Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7557",
    "data-name": "Path 7557",
    d: "M204.459,48.379l-.1.02-2.34-.87.02-.04Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7558",
    "data-name": "Path 7558",
    d: "M204.359,53.449l-.04.03-.94-.23-.02-.05.19.05Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7559",
    "data-name": "Path 7559",
    d: "M204.139,128.739l-.57-1.96h.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7560",
    "data-name": "Path 7560",
    d: "M203.989,35.7l-3.8.93h-.17l3.93-.96Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7561",
    "data-name": "Path 7561",
    d: "M203.829,42.859l.11.05-.12-.04Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7562",
    "data-name": "Path 7562",
    d: "M203.889,42.819l-.06.04-.1-.04-3.64-1.43.1-.03Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7563",
    "data-name": "Path 7563",
    d: "M203.829,42.859l-.01.01-.09-.04h-.01l-3.63-1.44,3.64,1.43Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7564",
    "data-name": "Path 7564",
    d: "M203.729,42.829l.09.04-1.81,1.16-.01-.01h-.14l1.86-1.19Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7565",
    "data-name": "Path 7565",
    d: "M203.719,42.829l-1.86,1.19h-3.74l-1.24-1.63,3.21-1Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7566",
    "data-name": "Path 7566",
    d: "M203.549,45.489l.01.02-.02-.02Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7567",
    "data-name": "Path 7567",
    d: "M203.559,45.519l-2.11,1.74h-.17l.01-.01h.16l1.56-1.28Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7568",
    "data-name": "Path 7568",
    d: "M203.559,45.509v.01l-.55.45-1.56,1.28h-.16l1.56-1.28.55-.45.14-.03Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7569",
    "data-name": "Path 7569",
    d: "M203.539,45.489l-.14.03-1.56-1.48.01-.01h.16Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7570",
    "data-name": "Path 7570",
    d: "M203.4,45.519l-.55.45h-.01l-1.55,1.28h-3.73l-3.08.71h-.01l-.6-1.8v-.01h2.14l.32-.1,2.72-.79v-.01l-.91-1.21h3.7Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7571",
    "data-name": "Path 7571",
    d: "M203.359,53.2l.02.05-.6-.15-2.87-3.32.16-.01,2.88,3.33Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7572",
    "data-name": "Path 7572",
    d: "M202.849,45.969l-1.56,1.28,1.55-1.28Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7573",
    "data-name": "Path 7573",
    d: "M202.689,112.449l-.38,1.1h-.01l.38-1.1Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7574",
    "data-name": "Path 7574",
    d: "M202.669,112.439l.01.01-.38,1.1h-8.55l.06-3.1h-1.34l.43-3.03,3.1-.18,3.56-7.36v-2.91l2.47,5.26h-2.01l1,2.96h.01l-.92,3.64.01.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7575",
    "data-name": "Path 7575",
    d: "M201.369,82.709l1.18,8.1-3,6.16h-13.31l-.41,2.01-.01.01-1.09.39-4.14-3.76,6.1-2.48v-4.48l8.77-5.95h5.91Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7576",
    "data-name": "Path 7576",
    d: "M202.049,47.479l-.01.01-.02.04-.14-.05-.6-.22h.17Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7577",
    "data-name": "Path 7577",
    d: "M202.029,123.949v.01l-3.78,1.72Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7578",
    "data-name": "Path 7578",
    d: "M202.019,47.529l-.01.01-.14-.05.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7579",
    "data-name": "Path 7579",
    d: "M202.009,47.539l-.77,1.33-1.77.93h-.01l-.18.01.01-.01,1.78-.93.8-1.38Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7580",
    "data-name": "Path 7580",
    d: "M202,44.019l.01.01h-.16l.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7581",
    "data-name": "Path 7581",
    d: "M201.879,47.479l-.01.01-.8,1.38-1.78.93-.18.01h-.01l-.67-1.24-.69-1.31h3.54Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7582",
    "data-name": "Path 7582",
    d: "M201.859,44.019l-.01.01h-3.73v-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7583",
    "data-name": "Path 7583",
    d: "M201.849,44.029l-.01.01-.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7584",
    "data-name": "Path 7584",
    d: "M201.5,57.359l.34,2.81-.16.09-.04-.3-.31-2.59-6.8-6.79h-2.2v-.01h2.37Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7585",
    "data-name": "Path 7585",
    d: "M201.829,44.029l.01.01h-3.7l-.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7586",
    "data-name": "Path 7586",
    d: "M201.769,49.769l.02.05-.03-.05Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7587",
    "data-name": "Path 7587",
    d: "M201.029,105.189l-.91,3.65-.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7588",
    "data-name": "Path 7588",
    d: "M201.029,105.179v.01h-.01l-1-2.96h.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7589",
    "data-name": "Path 7589",
    d: "M200.9,60.049v1.98l-.17-.03v-1.95Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7590",
    "data-name": "Path 7590",
    d: "M200.739,63.059l-.01,1.82-.17-.04.01-1.78Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7591",
    "data-name": "Path 7591",
    d: "M200.729,62v.04l-2.06-.32-1.23-.85v-.82h.17v.82l1.23.84Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7592",
    "data-name": "Path 7592",
    d: "M200.729,60.049V62l-1.89-.29-1.23-.84v-.82Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7593",
    "data-name": "Path 7593",
    d: "M198.639,113.549l2.02,6.53H196.7v3.53l-3.09-4.13.08-3.68h2.4v-2.25Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7594",
    "data-name": "Path 7594",
    d: "M200.569,63.059l-.01,1.78-1.91-.49.02-1.35Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7595",
    "data-name": "Path 7595",
    d: "M200.559,64.839v.04l-2.08-.53L198.5,63h.17l-.02,1.35Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7596",
    "data-name": "Path 7596",
    d: "M199.839,36.629l.35,4.73-.1.03-.01-.01.1-.03-.35-4.72Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7597",
    "data-name": "Path 7597",
    d: "M199.829,36.629l.35,4.72-.1.03-.06-.02-.35-4.73Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7598",
    "data-name": "Path 7598",
    d: "M200.089,41.389l-3.21,1-.01-.02,3.21-.99Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7599",
    "data-name": "Path 7599",
    d: "M200.079,41.379l-3.21.99.01.02h-.01l1.25,1.63v.01h-.17v-.01l-1.24-1.63,3.31-1.03Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7600",
    "data-name": "Path 7600",
    d: "M199.669,36.629l.35,4.73-3.31,1.03h-.01v-.01l3.31-1.03-.35-4.72-4.88-.06,5.05.05v.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7601",
    "data-name": "Path 7601",
    d: "M199.659,36.629l.35,4.72-3.31,1.03v.01l1.25,1.64.01.01.91,1.21-2.69.8-.34.1H192.1l-.85.39.46-2.3.15-.7v-.01l-1.61-.84.05-.91.04-.76.15-2.9,2.65-1.59-.35-.86h1.59l.23.9h.17Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7602",
    "data-name": "Path 7602",
    d: "M199.909,49.779l-.46.03.01-.01h.01l.43-.03Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7603",
    "data-name": "Path 7603",
    d: "M199.549,96.969v2.91l-3.55,7.36-3.1.18-.44,3.03H188.6l-.54-2.42-3.98-.58,1.62-7.86.13-.6v-.01l.42-2.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7604",
    "data-name": "Path 7604",
    d: "M199.289,49.8l-.01.01-.17.01v-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7605",
    "data-name": "Path 7605",
    d: "M198.429,48.569l.67,1.24h-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7606",
    "data-name": "Path 7606",
    d: "M198.429,48.569l.66,1.24-.15.01-.68-1.25-.68-1.28.11-.03h.03Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7607",
    "data-name": "Path 7607",
    d: "M195.919,30.529l3.17,3.64-.1.08-.5-.57-2.73-3.15.07-.11Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7608",
    "data-name": "Path 7608",
    d: "M198.139,44.039l.91,1.21h-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7609",
    "data-name": "Path 7609",
    d: "M199.049,45.249v.01l-2.72.79,2.71-.8Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7610",
    "data-name": "Path 7610",
    d: "M198.139,44.039l.9,1.21-2.71.8-.32.1h-.17l.34-.1,2.7-.79v-.01l-.91-1.21Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7611",
    "data-name": "Path 7611",
    d: "M197.969,44.039l.91,1.21h-.01l-.91-1.21Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7612",
    "data-name": "Path 7612",
    d: "M198.879,45.249v.01l-2.7.79,2.69-.8Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7613",
    "data-name": "Path 7613",
    d: "M198.429,48.569l-.71-1.31h.02Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7614",
    "data-name": "Path 7614",
    d: "M198.259,48.569l-.69-1.28h.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7615",
    "data-name": "Path 7615",
    d: "M198.139,44.039h-.18v-.01h.17Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7616",
    "data-name": "Path 7616",
    d: "M196.879,42.389l1.24,1.63-1.25-1.63Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7617",
    "data-name": "Path 7617",
    d: "M197.959,44.029v.01l-.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7618",
    "data-name": "Path 7618",
    d: "M197.949,44.019v.01l-1.25-1.64h.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7619",
    "data-name": "Path 7619",
    d: "M197.739,47.259h-.05l.04-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7620",
    "data-name": "Path 7620",
    d: "M197.729,47.249l-.04.01h-.13v-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7621",
    "data-name": "Path 7621",
    d: "M197.689,47.259l-.11.03-.01-.03Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7622",
    "data-name": "Path 7622",
    d: "M197.569,47.259l.01.03h-.01l-.02-.03h.02Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7623",
    "data-name": "Path 7623",
    d: "M197.569,47.289l-3.08.71-.01-.03v-.01l3.08-.71v.01h-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7624",
    "data-name": "Path 7624",
    d: "M197.509,34.529l-.51.76h-.16l.5-.75-.95-.94.12-.05Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7625",
    "data-name": "Path 7625",
    d: "M197.339,34.539l-.5.75-.5.01-.99.01.28-1.4.76-.31Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7626",
    "data-name": "Path 7626",
    d: "M196.879,67.549l-3.62,3.88,3.61-3.88Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7627",
    "data-name": "Path 7627",
    d: "M196.869,67.549l-3.61,3.88-1.93-9.28,4.3.12-.17,4.94Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7628",
    "data-name": "Path 7628",
    d: "M196.839,35.289l-.01.01h-.49Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7629",
    "data-name": "Path 7629",
    d: "M196.729,29l-.9,1.42h-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7630",
    "data-name": "Path 7630",
    d: "M196.339,33.549l.05.05-.76.31-.28,1.4h-.17l.28-1.4Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7631",
    "data-name": "Path 7631",
    d: "M196.089,113.549v2.25h-2.4l.06-2.25Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7632",
    "data-name": "Path 7632",
    d: "M195.579,30.129l.24.29-.07.11-.32-.38Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7633",
    "data-name": "Path 7633",
    d: "M193.259,71.429l2.35,11.28h-.15l-8.77,5.95-17.53-12.93v-1.39l10.41-5.69v-4.07l6.73-2.57,5.03.14Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7634",
    "data-name": "Path 7634",
    d: "M195.429,30.149l-4.88.8-.01-.03,4.87-.79Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7635",
    "data-name": "Path 7635",
    d: "M195.039,32.039l-.58,3.25.04.18.05.2h-.17l-.09-.38.58-3.25Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7636",
    "data-name": "Path 7636",
    d: "M194.869,32.039l-.58,3.25.09.38h-1.59l-.47-1.1,1.13-2.55Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7637",
    "data-name": "Path 7637",
    d: "M194.549,35.669l.23.9h-.17l-.23-.9Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7638",
    "data-name": "Path 7638",
    d: "M194.489,48v.01l-.37.08Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7639",
    "data-name": "Path 7639",
    d: "M194.489,48l-.37.09-1.34.31-.13-.01,1.67-.38V48l.16-.03Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7640",
    "data-name": "Path 7640",
    d: "M194.479,47.969l-.16.03.15-.04Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7641",
    "data-name": "Path 7641",
    d: "M193.869,46.159l.6,1.8-.15.04-.62-1.84Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7642",
    "data-name": "Path 7642",
    d: "M194.319,48v.01l-1.67.38Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7643",
    "data-name": "Path 7643",
    d: "M194.319,48l-1.67.39-1.75-.14.33-1.62.09-.04.95-.43h1.43Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7644",
    "data-name": "Path 7644",
    d: "M194.189,53.089l-.35,1.68-.16-.06.34-1.62Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7645",
    "data-name": "Path 7645",
    d: "M194.019,53.089l-.34,1.62-.62-.23v-1.39Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4750",
    "data-name": "Rectangle 4750",
    width: 0.17,
    height: 0.01,
    transform: "translate(1395.699 702.149)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7646",
    "data-name": "Path 7646",
    d: "M193.839,55.869v2.92h-.17v-2.92l-1.4-.4v-.06Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7647",
    "data-name": "Path 7647",
    d: "M193.679,54.709l-.01.07-.78-.3v-1.39h.17v1.39Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7648",
    "data-name": "Path 7648",
    d: "M193.669,58.789v.01H192.1v-3.38l.17.05v3.32Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7649",
    "data-name": "Path 7649",
    d: "M193.669,55.869v2.92h-1.4v-3.32Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7650",
    "data-name": "Path 7650",
    d: "M193.449,32.019l-1.13,2.55.47,1.1h-.17l-.47-1.1,1.13-2.55Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7651",
    "data-name": "Path 7651",
    d: "M192.789,35.669l.35.86-2.65,1.59-.18.1.01-.1,2.65-1.59-.35-.86Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7652",
    "data-name": "Path 7652",
    d: "M192.649,48.389l-.04.01-1.72-.13Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7653",
    "data-name": "Path 7653",
    d: "M192.649,48.389l-1.76-.12.01-.02Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7654",
    "data-name": "Path 7654",
    d: "M192.609,48.4l-1.72-.12v-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7655",
    "data-name": "Path 7655",
    d: "M190.6,49.7l1.89.87-1.9-.86.03-.12Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7656",
    "data-name": "Path 7656",
    d: "M192.489,50.569h-.16l-1.9-.87.29-1.43.16.01v.03l-.26,1.28-.03.12Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7657",
    "data-name": "Path 7657",
    d: "M192.329,50.569v.01h-.01l-.02-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7658",
    "data-name": "Path 7658",
    d: "M192.329,50.579l-.17,2.54h-.17l.17-2.55h.14l.02.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7659",
    "data-name": "Path 7659",
    d: "M192.329,50.569h-.03l-1.88-.86.3-1.44-.29,1.43Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7660",
    "data-name": "Path 7660",
    d: "M192.3,50.569h-.14l-.17,2.55-5.96-.04h-.17l-1.23,1.6h-.01l-4.06-2.61-.38-5-2.82-1.52v-1l2.23-.01h.17l6.44-3.87,3.04,1.59h.01l.13.07.7.37,1.61.84-.63,3.07-.01.02h.01l-.34,1.63v.01l-.3,1.44Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7661",
    "data-name": "Path 7661",
    d: "M192.269,46.149l-.02.01h-.15l-.86.39v-.01h.01l.85-.39Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7662",
    "data-name": "Path 7662",
    d: "M192.269,46.159l-.95.43.93-.43Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7663",
    "data-name": "Path 7663",
    d: "M192.249,46.159l-.93.43-.09.04.01-.07v-.01l.86-.39Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7664",
    "data-name": "Path 7664",
    d: "M191.859,43.529v.01l-1.61-.84v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7665",
    "data-name": "Path 7665",
    d: "M191.859,43.539l-.15.7-.47,2.3v.01l-.16.07-.02.01v-.02l.63-3.07v-.01l-1.61-.84v-.08l.17.09Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7666",
    "data-name": "Path 7666",
    d: "M191.239,46.539l.47-2.3-.46,2.3Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7667",
    "data-name": "Path 7667",
    d: "M191.689,43.529v.01l-1.61-.84v-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7668",
    "data-name": "Path 7668",
    d: "M191.239,46.559l-.01.07h-.01l.01-.07Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7669",
    "data-name": "Path 7669",
    d: "M191.239,46.549v.01h-.01l-.15.06Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7670",
    "data-name": "Path 7670",
    d: "M191.229,46.559l-.01.07h.01l-.33,1.62h-.01v.02l-.17-.01.34-1.63.02-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7671",
    "data-name": "Path 7671",
    d: "M191.059,46.609v.02h-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7672",
    "data-name": "Path 7672",
    d: "M190.9,48.249l-.01.02v-.02Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7673",
    "data-name": "Path 7673",
    d: "M190.889,48.269v.01h-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7674",
    "data-name": "Path 7674",
    d: "M190.889,48.279l-.01.03v-.03Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7675",
    "data-name": "Path 7675",
    d: "M190.889,48.269l-.01.01-.16-.01v-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7676",
    "data-name": "Path 7676",
    d: "M190.489,38.119l-.15,2.9-.16-.09.13-2.71Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7677",
    "data-name": "Path 7677",
    d: "M190.339,41.019l-.04.76h-.01l-.01.01-.16.08.01-.09.04-.75v-.1h.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7678",
    "data-name": "Path 7678",
    d: "M190.319,38.119l-.01.1-2.47,1.48-.08.05-.09-.05Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7679",
    "data-name": "Path 7679",
    d: "M187.839,39.7l2.47-1.48-.14,2.71Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7680",
    "data-name": "Path 7680",
    d: "M190.309,38.219l-.13,2.71h-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7681",
    "data-name": "Path 7681",
    d: "M190.3,41.779l-.05.91.04-.9v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7682",
    "data-name": "Path 7682",
    d: "M190.289,41.779v.01h-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7683",
    "data-name": "Path 7683",
    d: "M190.289,41.789l-.04.9-.16-.09.03-.72v-.01l.16-.08Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7684",
    "data-name": "Path 7684",
    d: "M190.249,42.689v.01l-.17-.09V42.6h.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7685",
    "data-name": "Path 7685",
    d: "M190.169,40.929v.1l-2.41-1.28.08-.05Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7686",
    "data-name": "Path 7686",
    d: "M190.169,41.029l-.04.75h-.01l-.24.13-.55.3h-.01l-3.02-1.59,1.46-.87Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7687",
    "data-name": "Path 7687",
    d: "M190.129,41.779l-.01.09v-.09Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7688",
    "data-name": "Path 7688",
    d: "M190.119,41.779v.01l-.24.12Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7689",
    "data-name": "Path 7689",
    d: "M190.119,41.869v.01l-.7.37-.09-.04.55-.3.24-.12Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7690",
    "data-name": "Path 7690",
    d: "M190.119,41.879l-.03.72h-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7691",
    "data-name": "Path 7691",
    d: "M190.119,41.879l-.04.72-.66-.35Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7692",
    "data-name": "Path 7692",
    d: "M190.079,42.6v.01l-.67-.35.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7693",
    "data-name": "Path 7693",
    d: "M190.079,42.609v.08l-.7-.36-.13-.07.07-.05.09.05Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7694",
    "data-name": "Path 7694",
    d: "M190.079,42.689v.01l-.7-.37Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7695",
    "data-name": "Path 7695",
    d: "M189.419,42.249l-.01.01-.09-.05h.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7696",
    "data-name": "Path 7696",
    d: "M186.3,40.619l3.02,1.59-3.03-1.58Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7697",
    "data-name": "Path 7697",
    d: "M189.319,42.209l-.07.05h-.01l-3.04-1.59.09-.05h.01l-.01.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7698",
    "data-name": "Path 7698",
    d: "M187.759,39.749l-1.46.87h-.01l-.09.05-.08-.04,1.55-.93Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7699",
    "data-name": "Path 7699",
    d: "M186.689,88.659v4.48l-13.59,5.5v3.55l-3.53-.7-.56-2.5v-.01h-2.87l-1.74-3.92v-1.64h7.68v-.01l-.04-.73-.69-12.34h4.04Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7700",
    "data-name": "Path 7700",
    d: "M186.249,96.969l-.42,2.01.41-2.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7701",
    "data-name": "Path 7701",
    d: "M186.2,40.669l-6.44,3.87h-.17l6.53-3.91Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7702",
    "data-name": "Path 7702",
    d: "M186.109,57.1v1.61h-.17v-1.46Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7703",
    "data-name": "Path 7703",
    d: "M186.029,53.079l-1.29,1.67-.11-.07,1.23-1.6Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7704",
    "data-name": "Path 7704",
    d: "M185.939,58.709v.01h-1.85l1.85-1.61v.14l-1.68,1.46Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7705",
    "data-name": "Path 7705",
    d: "M185.939,57.249v1.46h-1.68Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7706",
    "data-name": "Path 7706",
    d: "M185.829,98.979v.01h-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7707",
    "data-name": "Path 7707",
    d: "M185.829,98.989l-.13.6.12-.6Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7708",
    "data-name": "Path 7708",
    d: "M185.819,98.989l-.12.6-1.62,7.86-.74.21-1.22-7.31,2.61-.96h.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7709",
    "data-name": "Path 7709",
    d: "M185.819,98.989l-1.08.4h-.01v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7710",
    "data-name": "Path 7710",
    d: "M184.749,54.759l-5.92,7.6-.16-.01,5.91-7.59-.01-.01.05-.07h.01l.11.07Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7711",
    "data-name": "Path 7711",
    d: "M184.729,99.389l-2.61.96-1.73.64h-3.75v1.9l-3.54-.7v-3.55l7.48-3.02h.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7712",
    "data-name": "Path 7712",
    d: "M180.559,52.069l4.06,2.61-4.06-2.6h-.17l-.38-5-2.82-1.53v-1h.17v1l2.82,1.52Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7713",
    "data-name": "Path 7713",
    d: "M184.619,54.679l-.05.07-4.18-2.67h.17Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7714",
    "data-name": "Path 7714",
    d: "M184.579,54.759l-5.91,7.59-5.84-.44.89-7.43-2.88-.48.04-1.84,9.51-.07,4.18,2.66Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7715",
    "data-name": "Path 7715",
    d: "M184.569,54.749l-4.18-2.66-9.51.07v-.01l9.51-.07Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7716",
    "data-name": "Path 7716",
    d: "M184.409,38.459l-.16,1.42h-.17l.16-1.41-2.24-.48-2.8-6.43h.17l2.8,6.43Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7717",
    "data-name": "Path 7717",
    d: "M184.239,38.469l-.16,1.41h-.7l-.22,1.27-3.46.55-3.18.57,2.53-2.4-1.27-1.84,1.44-.79-.03-2.1-1.95-.18V31.5l1.96.06,2.8,6.43Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7718",
    "data-name": "Path 7718",
    d: "M183.549,39.879l-.22,1.26-3.46.55-3.39.62.04-.04,3.18-.57,3.46-.55.22-1.27Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7719",
    "data-name": "Path 7719",
    d: "M182.119,100.349l1.22,7.31-1.78.51-1.17-7.18Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7720",
    "data-name": "Path 7720",
    d: "M180.389,100.989l1.17,7.18-4.92,1.42v-8.6Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7721",
    "data-name": "Path 7721",
    d: "M179.569,64.579v4.07l-10.41,5.68v.62h-.73l-3.9.01,7.37-9.59,7.17-.75.5-.05Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7722",
    "data-name": "Path 7722",
    d: "M179.189,35.139l.03,2.1-1.44.79,1.27,1.84-2.53,2.4-.21.04,2.57-2.43-1.27-1.85,1.44-.79-.03-2.1-1.95-.18V31.5h.17v3.46Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7723",
    "data-name": "Path 7723",
    d: "M178.669,62.349l-.01.01-6-.44v-.01l.16.01.89-7.43-2.88-.48v.02l-.16-.03.04-1.84h.17l-.04,1.84,2.88.48-.89,7.43Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7724",
    "data-name": "Path 7724",
    d: "M176.639,102.889v6.7l-7.24,2.1v-4.57l-.98-1.1,1.15-1V101.5l3.53.69Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7725",
    "data-name": "Path 7725",
    d: "M176.489,35.289v1.37l-1.06.37-.03-.04.92-.33v-1.37l-2.32-.16-.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7726",
    "data-name": "Path 7726",
    d: "M176.319,35.289v1.37l-.92.33-1.4-1.86Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7727",
    "data-name": "Path 7727",
    d: "M175.429,37.039l.2,2.77-.17-.02-.2-2.75.12-.05.04.05Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7728",
    "data-name": "Path 7728",
    d: "M175.459,39.789v.02l-2.57-.35v-.03Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7729",
    "data-name": "Path 7729",
    d: "M175.259,37.039l.2,2.75-2.57-.36v.03l-.17-.02v1.27l-1.27.01v-3.74l2.43-1.78,1.37,1.84Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7730",
    "data-name": "Path 7730",
    d: "M175.429,37.029v.01h-.01l-.04-.05h.02Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7731",
    "data-name": "Path 7731",
    d: "M174,35.129l1.4,1.86h-.02Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7732",
    "data-name": "Path 7732",
    d: "M174,35.129l1.38,1.86-.12.05-1.38-1.84.1-.07Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7733",
    "data-name": "Path 7733",
    d: "M175.379,80.329h-4.04l.7,12.35.04.73H164.4v1.65l-6.37-4.59.18-5.42h5.19l1.56-2.34v-4.83h4.2v-2.14Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7734",
    "data-name": "Path 7734",
    d: "M173.879,35.2l1.38,1.84h-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7735",
    "data-name": "Path 7735",
    d: "M174.469,1.9l-.01.01L162.719.719Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7736",
    "data-name": "Path 7736",
    d: "M174.459,1.909l-1.59,1.6-4.52.93h-.01l-7.36,11.7-3.89,1.15h-.01l-5.58.34-2.75,2.12-7.37,2.18h-.01l-5.23,5.51h-3.41l-2.89-2.91-.13-5.2,4.59-2.62h.01v-3.83l-.01-.01-2.45-4.24h-.14l-9.45-.14V6.579l5.72-1.76.57-.17,7.88-2.74h13.69L161.4.589h.01l1.31.13Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7737",
    "data-name": "Path 7737",
    d: "M174,35.129h-.02l.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7738",
    "data-name": "Path 7738",
    d: "M173.979,35.129l-.1.07-.06-.08Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7739",
    "data-name": "Path 7739",
    d: "M173.819,35.119l.06.08-2.43,1.78v3.74h-.17v-3.74Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7740",
    "data-name": "Path 7740",
    d: "M173.709,54.489l-.89,7.43-.16-.01.89-7.43-2.72-.45v-.02Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7741",
    "data-name": "Path 7741",
    d: "M173.549,54.479l-.89,7.43h-.01l.89-7.42-2.71-.45v-.01Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7742",
    "data-name": "Path 7742",
    d: "M173.539,54.489l-.89,7.42-.59-.05-1.37-2.42.14-5.4Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7743",
    "data-name": "Path 7743",
    d: "M172.889,39.459v1.25h-.17v-1.27Z",
    transform: "translate(1202 656)",
    fill: "#ff9947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7744",
    "data-name": "Path 7744",
    d: "M172.649,61.909v.01l-.76-.06-1.37-2.42.14-5.43.17.03-.14,5.4,1.37,2.42Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7745",
    "data-name": "Path 7745",
    d: "M170.049,21.689v.53l-3.86,1.88-6.46-.92v-1.72l1.83.04.68-.93,3.22.07,2.68-.89Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7746",
    "data-name": "Path 7746",
    d: "M169.569,101.5v3.52l-1.15,1-1.64-1.85v-.01l-2.38-2.66-2.3,2.31-2.46-2.66,2.07-2.16h7.3l.56,2.5Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7747",
    "data-name": "Path 7747",
    d: "M169.4,107.119v4.56l-4.94-5.33,2.32-2.18,1.64,1.85Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7748",
    "data-name": "Path 7748",
    d: "M169.159,75.739v2.14h-.01v-2.15h.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7749",
    "data-name": "Path 7749",
    d: "M169.159,74.959v.77h-.01v2.15h-4.2v4.83l-1.55,2.34h-5.18l.07-1.96,6.24-8.13Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7750",
    "data-name": "Path 7750",
    d: "M166.779,104.159v.01l-2.32,2.18Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7751",
    "data-name": "Path 7751",
    d: "M166.779,104.159l-2.32,2.19-2.36-2.54,2.3-2.31Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7752",
    "data-name": "Path 7752",
    d: "M164.4,95.059l1.74,3.92v.01h-8.42l.08-2.02h4.23l-4.19-1.22.19-5.28Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7753",
    "data-name": "Path 7753",
    d: "M164.959,77.879v4.83l-1.56,2.34,1.55-2.34v-4.83Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7754",
    "data-name": "Path 7754",
    d: "M162.029,96.969H157.8l.04-1.22Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7755",
    "data-name": "Path 7755",
    d: "M161.709,98.989l-2.07,2.16-1.92-2.07.01-.09Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7756",
    "data-name": "Path 7756",
    d: "M161.4.589l-11.28,1.32h-13.69l-7.88,2.74,7.88-2.75h13.68Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7757",
    "data-name": "Path 7757",
    d: "M134.309,12.879v3.83h-.01v-3.84Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7758",
    "data-name": "Path 7758",
    d: "M131.849,8.629l2.45,4.24-2.46-4.24Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7759",
    "data-name": "Path 7759",
    d: "M134.3,16.709l-4.59,2.62.13,5.2-.01-.01-.13-5.2Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7760",
    "data-name": "Path 7760",
    d: "M133.129,126.149v3.38l-4.28,5.6-1.84,13.71-9.92,4.39-.96,6.17-4.08,7.12-7-4.8,4.09-4.2-.11-1.57h-.01l-.17-2.39-6.33-3.37-.12-3.83-.1-3.25-7.4-6.05-3.81-3.91-4.25,1.2-1.39.39-6.26-5.39,1.65-5.38,3.74-.46v-1.46h.01v-8.04l2.91-.2h.01l.76-.05.97,2.17h.01l3.1-1h.01l-.25-3.37,4.15-1.53h.01l1.8-.66-.01.24-.24,4.96,4.16-.47,1.7-.19,2.04-.22,2.79-.32.82-2.34,1.92,4.18-2.17,3.2,2.98-2.3,2.1.91-1.03,2.77,3.17-1.85,3.16,1.37-.18,1.87,6.85.42Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7761",
    "data-name": "Path 7761",
    d: "M129.839,24.529l2.89,2.91h-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7762",
    "data-name": "Path 7762",
    d: "M132.369.249l-4.93,2.79-6.51,1.3-8.08,3.77-.89-.76h-5.54l-.76-.75h5.07l-1.17-1.51,2.95.48L111.619,4l6.85-.14.93-1.23-6.61.13V1.709Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7763",
    "data-name": "Path 7763",
    d: "M127.979,4.819l-5.72,1.76v1.91h-.02V6.569Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7764",
    "data-name": "Path 7764",
    d: "M118.119,18.419l.99,1.86-1.76,1.17-3.06-1.09v3.98l-.87.37-2.66-1.26.92,2.03-1.06.46-3.87-3.2h-4.56v-1.29h4.5l2-1.63,3.96.06-5.89-5.27-7.6.41-2.06.11,3.98-4.22,1.65.01-1.14,2.82,3.41-2.8,1.46.02,9.81,4.01.08,2.81Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7765",
    "data-name": "Path 7765",
    d: "M117.189,43.229l1.68,2.67h-8.05l.04-.04h7.97l-1.66-2.63Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7766",
    "data-name": "Path 7766",
    d: "M117.169,43.229l1.66,2.63h-7.97l4.78-4.86v1.83l.04.01v.03h.01l1.48.35Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7767",
    "data-name": "Path 7767",
    d: "M43.719,15.849v-.01l19.61-.41,10.29,4.11,4.23-1.98,8.01,1.5,4.6-2.19-.9-1.85L93,13.5l.47,2.9,1.98.2-.48,2.4,4.25-2.81,3.08.35-3.29,3.42-8.08.89,1.1,1.62-5.25.96-9.25,6.85,9.25,5.02-.05,5.14h2.6l10.74-15.64h3.98l2.92,2.49-.04,3.57,6.06-2.39.57,7.58,4.63.8-.03,1.54-6.36,3.39-8.47.36-5.28,2.54v1.44l5.52-2.5.86.82-1.76,2.73,1.78,1.6,3.81.18-7.81,2.74-.27-1.19,2.87-1.37-4.31.75.65-2.08.22-.67v-.01h-.06l.01-.04H97.1l-2.74,2.37h-6.35l-1.96,1.35h-2.83l-.87-2.62-2.23.16-1.33-.98-.82-2.91-6.57,1.39-3.88-1.77H34.509v-1.44l-2.95-2.67,1.65-7.52.02-.03.02.02,1.62-1.74-1.42-1.47h-1.6l-1.56-1.78,13.42-11.59Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7768",
    "data-name": "Path 7768",
    d: "M117.149,43.189l.02.03-1.48-.35v-.03Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4751",
    "data-name": "Rectangle 4751",
    width: 0.01,
    height: 0.03,
    transform: "translate(1317.679 698.839)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7769",
    "data-name": "Path 7769",
    d: "M115.679,40.959v1.88l-.04-.01V41Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7770",
    "data-name": "Path 7770",
    d: "M115.679,40.959l-.04.04v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7771",
    "data-name": "Path 7771",
    d: "M115.639,40.909V41l-4.8,4.86h-.08Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7772",
    "data-name": "Path 7772",
    d: "M115.639,41l-4.78,4.86h-.02Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7773",
    "data-name": "Path 7773",
    d: "M112.049,166.519l-2,3.48-5-1.84v-6.43Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7774",
    "data-name": "Path 7774",
    d: "M112.049,166.519l-7-4.79v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7775",
    "data-name": "Path 7775",
    d: "M111.619,8.349l-2.47,1.73-9.45-.74,2.33-1.99,2.4,1Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7776",
    "data-name": "Path 7776",
    d: "M110.859,45.859l-.04.04h-.02l.04-.04Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7777",
    "data-name": "Path 7777",
    d: "M108.229,108.629l1.1,2.4-.82,2.34-2.79.31.18-5.25Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7778",
    "data-name": "Path 7778",
    d: "M105.049,168.159l4.2,5.85-9.27,4.01.82,17.13-1.59-.17-4.37-6.69-.14-3.93-2.94-5.24-3.26-14.24,1.55-14.38h5.77l.39-.71,6.9,4.68v3.01h3.4l2.51-1.52.11,1.56-4.09,4.2h.01v6.44Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7779",
    "data-name": "Path 7779",
    d: "M109.209,3.529l-2.09,1.34-3.65-.69L107.7,2.4Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7780",
    "data-name": "Path 7780",
    d: "M109.029,155.949l.11,1.57-4.09,4.2h-.01l4.09-4.2-.11-1.56v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7781",
    "data-name": "Path 7781",
    d: "M108.849,153.559l.17,2.39-2.51,1.53h-3.39v-3.01h-.01l-6.9-4.68H96.2l1.85-3.4,4.35-.03.12,3.83Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7782",
    "data-name": "Path 7782",
    d: "M108.509,113.369l-2.79.32v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7783",
    "data-name": "Path 7783",
    d: "M107.8,199.339l-5.77-.21-1.87-1.72,1.42-1.32Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7784",
    "data-name": "Path 7784",
    d: "M105.9,108.429l-.18,5.25-2.04.23-1.7.18-1.42-3.64,1.28-2.37v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7785",
    "data-name": "Path 7785",
    d: "M105.719,113.679v.01l-2.04.22Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4752",
    "data-name": "Rectangle 4752",
    width: 0.01,
    height: 3.01,
    transform: "translate(1305.109 810.469)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7786",
    "data-name": "Path 7786",
    d: "M102.3,143.109l.1,3.25-4.34.02-.01.01-1.85,3.4-.39.71h-5.77l-3.2-6.44v-9.71l4.25-1.2,3.81,3.91Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7787",
    "data-name": "Path 7787",
    d: "M101.979,114.089v.01l-4.15.46.23-4.95.01-.24v-.01l-1.8.67,1.24-6.07,4.33,4.12-1.28,2.37Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7788",
    "data-name": "Path 7788",
    d: "M101.979,114.1l-4.16.47.24-4.96-.23,4.95Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7789",
    "data-name": "Path 7789",
    d: "M99.609,47.119v.01h-.07l.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7790",
    "data-name": "Path 7790",
    d: "M99.609,47.129l-.22.67-.66,2.08-.06.01.87-2.76Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7791",
    "data-name": "Path 7791",
    d: "M99.539,47.129l-.87,2.76.06-.01-.02.06-1.56.27-23.1,19.75h-.01l-.06,8.88-2.26-.06-.94-7.13v-.01l-14.27-.04H56.5l-5.99,7.53H50.5l-3.21-6.32h-.01V72.8l-3.89.14-1.12-1.69-.73-1.11h-.01v-.01l-13.88-1.79v.01l-3.97-3.96v-8.82l10.87-11.46h33l3.84,1.75.03.02-.76,1.65h1.87l1.6-.77,1.27.77,2.7.1.23.76-4.09.88-.1.17-3.37,5.44v.01h1.8v-.01l3.07-4.51,1.65-1.1H78.7l-.37,3.14v.01l1.83-.19,1.79-1.39H86.1L84,52.279h1.5l2.11-1.44H86.1l1.96-1.35h6.35l2.73-2.36Zm-19.33,7.76,2.13-1.47h-2.59l-2.14,1.46h.02l-.01.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7792",
    "data-name": "Path 7792",
    d: "M98.729,49.879l.66-2.08-.65,2.08Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7793",
    "data-name": "Path 7793",
    d: "M94.829,188.289l4.37,6.7-1.97-.2-6.09-7.88-.17-5.83-3.51-2.84-1.33-32.54.71-1.64,3.2,6.44v.01l-1.55,14.37,3.26,14.25,2.94,5.23Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7794",
    "data-name": "Path 7794",
    d: "M98.069,109.359v.01l-1.8.66Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7795",
    "data-name": "Path 7795",
    d: "M97.169,10.429l.89,1.17-4.38,1.16-.41-1.43Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7796",
    "data-name": "Path 7796",
    d: "M98.059,22.739l-.53,1.29-4.98-.53,2.52-2.05Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7797",
    "data-name": "Path 7797",
    d: "M97.509,103.939v.02l-.02-.02-1.23,6.09-4.17,1.53.26,3.37-3.1,1-.97-2.17h-.01l-.76.05v-6.39H87.5l-4.78-.49-2.08-2.3-.38-4.48-.03-.37,7.2.06,3.1,2.21,5.58.55Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7798",
    "data-name": "Path 7798",
    d: "M97.489,103.939l.02.02-1.24,6.07h-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7799",
    "data-name": "Path 7799",
    d: "M96.259,110.029l-4.15,1.53.25,3.37h-.01l-.26-3.37Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7800",
    "data-name": "Path 7800",
    d: "M92.689,10.419l-.84,2.25-3.21,1.07-1.5-1.51Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7801",
    "data-name": "Path 7801",
    d: "M90.839,89.119l-.52.85H88.9l.52-.85Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7802",
    "data-name": "Path 7802",
    d: "M87.929,15.139l.7,1.11-2.35,1.2-.92-1.2Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7803",
    "data-name": "Path 7803",
    d: "M75.709,103.889l3.05-4.13,1.47.01v.01l.03.37.37,4.48,2.08,2.3h.01l4.78.49v6.39l-2.91.19v.01h-.01v8.03l-7.04-4.02-5.13-2.93-.37-.21h-.01l1.78-2.25.6-3.89-.19-.63-.43-1.46.81-1.16-.38-1.4-.03-.1Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7804",
    "data-name": "Path 7804",
    d: "M87.5,87.949l-.01.01-4.13-.46v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7805",
    "data-name": "Path 7805",
    d: "M87.489,87.959l-.54.79h-2.21l-1.38,1.03V87.5Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7806",
    "data-name": "Path 7806",
    d: "M86.839,134.359v9.7l-.71,1.64-7.94-5.32-9.18-15.64.1-1.55h.01l3.01,1.45h.01l5.39-6.61,7.05,4.02v1.46l-3.74.46-1.66,5.39,6.26,5.39Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7807",
    "data-name": "Path 7807",
    d: "M84.589,114.009v8.04h-.01v-8.04Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7808",
    "data-name": "Path 7808",
    d: "M84.449,15.9l-3.03.7-4.04-.96-3.63,1.58-5.28-2.05,4.25-1.09L70,12.939l4.62-1.57,2.53,1.16,2.42-.94.55,1.78,1.37-1.78h2.28l-2.28,2.95Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7809",
    "data-name": "Path 7809",
    d: "M83.359,87.5v1.72h-3.25v-.53h1.51l-.84-1.19Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7810",
    "data-name": "Path 7810",
    d: "M83.359,87.489v.01h-2.58l-.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7811",
    "data-name": "Path 7811",
    d: "M82.339,53.419l-2.13,1.47h-2.59l.01-.01H80.2Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7812",
    "data-name": "Path 7812",
    d: "M80.779,87.5l.84,1.19h-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7813",
    "data-name": "Path 7813",
    d: "M73.079,82.149l7.03,5.07h-5.88l1.3-1.44-3.4-2.26h-4.21l1.44-1.37Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7814",
    "data-name": "Path 7814",
    d: "M77.539,118.019l-.01.01-.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7815",
    "data-name": "Path 7815",
    d: "M77.539,118.019h-.02l-5.11-2.93Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7816",
    "data-name": "Path 7816",
    d: "M77.519,118.019l.01.01-5.39,6.61h-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7817",
    "data-name": "Path 7817",
    d: "M72.409,115.089l5.11,2.93-5.39,6.62-3.01-1.45.31-5.02,2.61-3.29Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7818",
    "data-name": "Path 7818",
    d: "M77.239,89.679v.89H74.7l-.88-.75v-1.03h2.53Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7819",
    "data-name": "Path 7819",
    d: "M74.219,104.089l.38,1.4-.1-.33-.29-1.08-.02-.09Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7820",
    "data-name": "Path 7820",
    d: "M74.5,105.159l.1.33-.08-.25Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7821",
    "data-name": "Path 7821",
    d: "M74.6,105.489l-.81,1.16-.01-.02Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7822",
    "data-name": "Path 7822",
    d: "M74.519,105.239l.07.24-.81,1.14-.61-1.99h-.01v-.01l-2.1-.2-.89,1.32-3.65-1.3v-.01l1.24-1.6,1.53.84.01.01,1.17-.97,3.28-.29.43,1.57h-.03l.35,1.17Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7823",
    "data-name": "Path 7823",
    d: "M74.5,105.159l-.34-1.17h.03l.02.09Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7824",
    "data-name": "Path 7824",
    d: "M74.159,103.989l.34,1.17-.35-1.17Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7825",
    "data-name": "Path 7825",
    d: "M74.219,108.109l-.44-1.47v-.01l.01.02Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7826",
    "data-name": "Path 7826",
    d: "M74.139,49.439l-3.36,5.44h-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7827",
    "data-name": "Path 7827",
    d: "M73.779,106.619v.01l-.01.01-.61-2.01h.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7828",
    "data-name": "Path 7828",
    d: "M73.749,102.409v.01l-3.28.29-1.17.97-.01-.01,1.17-.97Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7829",
    "data-name": "Path 7829",
    d: "M73.509,10.829l-8.57,2.92-1.5-1.77,8.1-2.06Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7830",
    "data-name": "Path 7830",
    d: "M71.429,45.879l-.77,1.65.76-1.65Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7831",
    "data-name": "Path 7831",
    d: "M70.779,71.639v.01l-14.27-.05Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7832",
    "data-name": "Path 7832",
    d: "M67.749,102.819l.01.01-1.24,1.6,1.14-1.49Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7833",
    "data-name": "Path 7833",
    d: "M67.749,102.819l-.09.12-1.15,1.49v.01l-.88-.31-.01-.01-2.45-3.32,3.68.39.03,1.15h.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7834",
    "data-name": "Path 7834",
    d: "M67.659,102.939l-1.14,1.49h-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7835",
    "data-name": "Path 7835",
    d: "M66.679,93.139l.18,8.04-3.69-.39-2.16-2.9.73-.62Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7836",
    "data-name": "Path 7836",
    d: "M66.679,93.139l-4.94,4.13-.73.61-.61-.27.41-1.46H60.8l-.64-.28-1.44-.65.1-.17,1.03-1.84Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7837",
    "data-name": "Path 7837",
    d: "M63.169,100.8l2.45,3.32-2.46-3.32Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7838",
    "data-name": "Path 7838",
    d: "M62.679,85.309l-.11,2.9-.11.08.05-.1.01-.01v-.01l-2.68,1.99h-2.05v.01l.04.3.3,2.32h-2.4L54.6,94.8l-2.24-2.28-2.6.69-10.4-4.34-6.38-14.98-.07-3.76h-1.99v4.04l3.37,7.18-1.75,1.35-4.27-8.08-.59-6.25-.02-.02,13.87,1.79,1.85,2.8v.01l3.77-.14h.13l3.22,6.32-2.58,3.24.01.01,3.11,6.69v.01l6.39-.01,2.32-3.82Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7839",
    "data-name": "Path 7839",
    d: "M62.519,88.169v.01l-.01.01-2.66,1.98h-.01v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7840",
    "data-name": "Path 7840",
    d: "M62.509,88.189l-.05.1-.01.01L59.9,90.2h-.04l-.01-.03Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7841",
    "data-name": "Path 7841",
    d: "M62.449,88.3l-2.15,4.06-.44-2.16h.04Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7842",
    "data-name": "Path 7842",
    d: "M61.739,97.269l-.73.62v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7843",
    "data-name": "Path 7843",
    d: "M60.809,96.149l-.41,1.46-.01-.01.41-1.45Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7844",
    "data-name": "Path 7844",
    d: "M60.8,96.149l-.41,1.45L58,96.529l.72-1.3,1.44.64Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7845",
    "data-name": "Path 7845",
    d: "M60.3,92.359l-.01.01-.44-2.17h.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7846",
    "data-name": "Path 7846",
    d: "M59.849,90.2l.44,2.17-2.3,4.15-3.34-1.68,1.13-2.01h2.4l-.34-2.63Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7847",
    "data-name": "Path 7847",
    d: "M60.159,95.869l-1.44-.64v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7848",
    "data-name": "Path 7848",
    d: "M59.849,90.169l.01.03h-.01l-.01-.03Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7849",
    "data-name": "Path 7849",
    d: "M59.849,93.209l-1.03,1.84.32-.59Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7850",
    "data-name": "Path 7850",
    d: "M59.839,90.169l.01.03h-2.01l.34,2.63h-2.4l-1.13,2.01-.02-.01-.02-.02,1.13-2.02h2.4l-.31-2.32-.04-.3Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4753",
    "data-name": "Rectangle 4753",
    width: 2.05,
    height: 0.01,
    transform: "translate(1259.789 746.159)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7851",
    "data-name": "Path 7851",
    d: "M58.719,95.229l-.72,1.3-.01-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7852",
    "data-name": "Path 7852",
    d: "M57.829,90.469l.31,2.32h-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7853",
    "data-name": "Path 7853",
    d: "M57.429,89.069l-6.39.01v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7854",
    "data-name": "Path 7854",
    d: "M55.739,92.789l-1.13,2.02-.01-.01,1.13-2.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7855",
    "data-name": "Path 7855",
    d: "M54.609,94.809l.02.02-.03-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4754",
    "data-name": "Rectangle 4754",
    width: 0.014,
    height: 0.014,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 1256.589, 750.809)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7856",
    "data-name": "Path 7856",
    d: "M47.289,72.809l3.21,6.32-3.22-6.32Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7857",
    "data-name": "Path 7857",
    d: "M47.279,72.8v.01h-.13l-3.76.13Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7858",
    "data-name": "Path 7858",
    d: "M47.149,72.809l-3.77.14v-.01h.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7859",
    "data-name": "Path 7859",
    d: "M43.7,15.839l.01.01-13.42,11.59,1.56,1.78h1.6l1.42,1.47-1.62,1.74-.02-.02,1.6-1.72-1.42-1.46h-1.6l-1.56-1.79,13.43-11.6Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7860",
    "data-name": "Path 7860",
    d: "M40.629,14.569l3.05,1.27-13.43,11.6,1.56,1.79h1.6l1.42,1.46-1.6,1.72-4.28-4.27-14.12.49-12.24,5.85-2.34-.19,6.41-4.19h-.03l.02-.01-3.33.06,3.89-5.26,8.03-3.01H15.2l.03-.01L9,22.1l1.4-1.96,7.39.09h.01v-2.92l6.57-2.65Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7861",
    "data-name": "Path 7861",
    d: "M42.269,71.249l1.12,1.69h-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7862",
    "data-name": "Path 7862",
    d: "M42.269,71.249l1.11,1.69-1.85-2.8Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7863",
    "data-name": "Path 7863",
    d: "M42.269,71.249l-.74-1.11h.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7864",
    "data-name": "Path 7864",
    d: "M41.529,70.129v.01l-13.88-1.8Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7865",
    "data-name": "Path 7865",
    d: "M41.529,70.139l-13.87-1.79h-.01v-.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7866",
    "data-name": "Path 7866",
    d: "M33.089,43.029v1.03h-1.63l-1.56-2.04.96-.82Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4755",
    "data-name": "Rectangle 4755",
    width: 0.01,
    height: 2.92,
    transform: "translate(1219.789 673.309)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7867",
    "data-name": "Path 7867",
    d: "M15.239,21.879l-8.03,3.01,7.99-3.01Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7868",
    "data-name": "Path 7868",
    d: "M10.4,20.139,9,22.1h-.01l1.4-1.96Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7869",
    "data-name": "Path 7869",
    d: "M7.209,24.889l-3.89,5.26h-.01l3.89-5.26Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7870",
    "data-name": "Path 7870",
    d: "M6.659,30.1l-6.41,4.19,6.38-4.19Z",
    transform: "translate(1202 656)",
    fill: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7871",
    "data-name": "Path 7871",
    d: "M216.909,161.2l1.56-1h1.64",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7872",
    "data-name": "Path 7872",
    d: "M220.109,161.759v.03l-1.19,1.24h-2.01V163",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7873",
    "data-name": "Path 7873",
    d: "M208.059,159.579v.03H202.4l3.28,8.99h10.77l8.29-9.6.38-2.59-1.56.02",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7874",
    "data-name": "Path 7874",
    d: "M223.559,150.839h-3.92l-9.3,6.23-2.28-2.63",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_901",
    "data-name": "Line 901",
    x2: 1.53,
    transform: "translate(1424.029 811.909)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7875",
    "data-name": "Path 7875",
    d: "M223.559,158.2v.03l-1.53-.92v-.03",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7876",
    "data-name": "Path 7876",
    d: "M82.339,53.419l-2.14,1.46h-2.59l2.14-1.46",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7877",
    "data-name": "Path 7877",
    d: "M99.609,47.129h-2.47",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7878",
    "data-name": "Path 7878",
    d: "M98.709,49.939l.02-.06.66-2.08",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7879",
    "data-name": "Path 7879",
    d: "M73.979,78.839l.06-8.88h.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7880",
    "data-name": "Path 7880",
    d: "M50.509,79.129,56.5,71.6h.01l14.27.05",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_902",
    "data-name": "Line 902",
    x2: 3.22,
    y2: 6.32,
    transform: "translate(1249.279 728.809)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7881",
    "data-name": "Path 7881",
    d: "M41.529,70.139l1.85,2.8v.01l3.77-.14",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7882",
    "data-name": "Path 7882",
    d: "M70.659,47.529l.77-1.65h-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7883",
    "data-name": "Path 7883",
    d: "M78.1,47.629l-2.7-.1-1.27-.77-1.6.77",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_903",
    "data-name": "Line 903",
    y1: 5.44,
    x2: 3.36,
    transform: "translate(1272.779 705.439)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7884",
    "data-name": "Path 7884",
    d: "M78.7,49.269h-1.41l-1.65,1.1-3.07,4.51v.01h-1.8v-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7885",
    "data-name": "Path 7885",
    d: "M80.159,52.229l-1.83.19v-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7886",
    "data-name": "Path 7886",
    d: "M115.639,41l-4.8,4.86-.04.04h.02",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7887",
    "data-name": "Path 7887",
    d: "M115.679,40.949v.01l-.04.03",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7888",
    "data-name": "Path 7888",
    d: "M115.689,42.869h-.01v-1.91",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7889",
    "data-name": "Path 7889",
    d: "M118.869,45.9l-1.68-2.67h-.02",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_904",
    "data-name": "Line 904",
    x1: 6.39,
    transform: "translate(1253.039 745.069)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7890",
    "data-name": "Path 7890",
    d: "M41.529,70.139v-.01l-13.88-1.79",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7891",
    "data-name": "Path 7891",
    d: "M47.279,72.809V72.8l-3.89.14h-.01l-1.11-1.69",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7892",
    "data-name": "Path 7892",
    d: "M47.929,82.379l-.01-.01,2.58-3.24",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7893",
    "data-name": "Path 7893",
    d: "M166.189,24.1l3.86-1.88v-.53l-1.91-1.94-2.68.89-3.22-.07-.68.93-1.83-.04v1.72Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7894",
    "data-name": "Path 7894",
    d: "M198.669,63h-.17l-.02,1.35,2.08.53v-.04",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7895",
    "data-name": "Path 7895",
    d: "M161.4.589,150.109,1.9h-13.68l-7.88,2.75",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7896",
    "data-name": "Path 7896",
    d: "M172.869,3.509l1.59-1.6.01-.01L162.719.719",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7897",
    "data-name": "Path 7897",
    d: "M160.979,16.139l7.36-11.7h.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7898",
    "data-name": "Path 7898",
    d: "M148.749,19.749l2.75-2.12,5.58-.34",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7899",
    "data-name": "Path 7899",
    d: "M131.839,8.629l2.46,4.24v3.84l-4.6,2.61.13,5.2.01.01,2.88,2.91h3.42l5.23-5.51h.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7900",
    "data-name": "Path 7900",
    d: "M127.979,4.819l-5.74,1.75v1.92h.02l9.45.14",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7901",
    "data-name": "Path 7901",
    d: "M344.739,80.609l-1.12-1.17-1.83,2.6,1.83,1.71Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7902",
    "data-name": "Path 7902",
    d: "M287.769,44.879l14.76,8.62,17.08.19,2.05-4.19,5.52-1.15",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7903",
    "data-name": "Path 7903",
    d: "M322.249,43.279h-7.31l-14.93-3.7-.01.01-1.63,3.69h-.01l-6.06-1.85-.02.01-4.51,3.44",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7904",
    "data-name": "Path 7904",
    d: "M327.549,46.3v-.01l-3.84-.61",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7905",
    "data-name": "Path 7905",
    d: "M330.419,87.449l-2.19.49v1.29l.89,1.08,1.3-1.62Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7906",
    "data-name": "Path 7906",
    d: "M345.439,53.5v-7.21l-8.94-2.28-6.58-6.44h-6.38v.01l1.45,5.15h-.02",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7907",
    "data-name": "Path 7907",
    d: "M326.479,85.389l.01.01,1.8-1.02.06,1.74,10.62-3.79,3.47-7.77-6.19-10.19,3.18-3.47h-3.66l-1.17.76-2.3-3.77,2.92-2.56,2.01,3.83,2.81-1.93,2.13-1.47",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7908",
    "data-name": "Path 7908",
    d: "M313.019,76.289l-.96,2.6,3.7,6.16",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_905",
    "data-name": "Line 905",
    x2: 4.84,
    y2: 2.09,
    transform: "translate(1508.029 729.279)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7909",
    "data-name": "Path 7909",
    d: "M299.589,75.2h.01l3.15,1.09",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7910",
    "data-name": "Path 7910",
    d: "M284.669,64.649l.27,5.48h.01l2.41.84h.01l11.4,3.94",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7911",
    "data-name": "Path 7911",
    d: "M276.049,57.069h-.01l.57,1.39,1.26,3.09h.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7912",
    "data-name": "Path 7912",
    d: "M281.379,49.749l-.01.01,1.07,4.93",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7913",
    "data-name": "Path 7913",
    d: "M322.249,43.289l1.46,2.39,3.84.62-.37,2.05-5.51,1.16-2.06,4.18-17.08-.18-14.77-8.62",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7914",
    "data-name": "Path 7914",
    d: "M359.149,54.129l2.5-.03,1.06-1.82-5.55-2.33.11,4.59,1.1.65Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7915",
    "data-name": "Path 7915",
    d: "M352.249,64.739l-.41,1.41,5.5-.81.43,2.12,1.25-.53.13-1.68,3.69-.94-.2-4.83-1.67-2.92-1.67-.49.95,4.39-3.4,3.09Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7916",
    "data-name": "Path 7916",
    d: "M351.279,67.459l1.99-.25.65.96-.72,2.26Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7917",
    "data-name": "Path 7917",
    d: "M356.589,66.529l-.96,1.74-1.27-1.44Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7918",
    "data-name": "Path 7918",
    d: "M350.569,96.329l-3.02-.32-1.1-1.37,1.1-2.52-1.09-2.41-1.99-.04-.49,4.25,2.82,3.39,3.3.42Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7919",
    "data-name": "Path 7919",
    d: "M341.059,103.869l1.33.26,2.38-1.97-.05-1.62Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7920",
    "data-name": "Path 7920",
    d: "M351.479,106.919v1.9l1.98-.6-.67-1.22,1.6-.41-1.36-4.24-1,2.62h-3.29Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7921",
    "data-name": "Path 7921",
    d: "M345.629,97.449l1.41,1.39-.46.85-1.14-1.11Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7922",
    "data-name": "Path 7922",
    d: "M347.039,100.849l1,.68,1.1-1.66-1.46-.18Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7923",
    "data-name": "Path 7923",
    d: "M350.779,99.109l1.38,1.78h1.51l-1.44-2.31Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7924",
    "data-name": "Path 7924",
    d: "M350.779,100.609l.78,1.36-.62.82-1.09-1.64Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7925",
    "data-name": "Path 7925",
    d: "M349.139,101.979l.71,1.07-.71.85-.8-.99Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7926",
    "data-name": "Path 7926",
    d: "M352.749,131.119l2.6-.31v-.97h-3.53v.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_906",
    "data-name": "Line 906",
    x1: 2.37,
    y2: 0.25,
    transform: "translate(1542.699 766.349)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7927",
    "data-name": "Path 7927",
    d: "M330.949,114.829l-.04.01.13,3.68,2.09,3.66h6.65l3.29-4.2v-7.62",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7928",
    "data-name": "Path 7928",
    d: "M326.179,124.439v-2.81l-10.96-11.38-3.75-1.43,12.7,17.29Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7929",
    "data-name": "Path 7929",
    d: "M338.989,129.439l.2.95-13.7-2.32,2.06-1.65,3.42,1.3,3.08-.68Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7930",
    "data-name": "Path 7930",
    d: "M347.749,129.439h-2.12l.41,1.37h2.02l.85-.69Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7931",
    "data-name": "Path 7931",
    d: "M344.049,131.659l.62.76h1.47l-.51-1.1Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7932",
    "data-name": "Path 7932",
    d: "M351.819,129.849l-2.12,2.36,1.61.2,1.44-1.29Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7933",
    "data-name": "Path 7933",
    d: "M344.769,125.669l1.58-.48-.48-2.78.93-1.03.78,2.06,1.89.66v-1.48l-1.07-2.35,2.02-1.69-3.22.13-.66-.91,1.28-1.4,2.36.81,1.17-.1,1.74-2.06-1.53-.03-1,.65-3.29-.8-2.18,1.97.15,3.11-1.26,1.69Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7934",
    "data-name": "Path 7934",
    d: "M356.589,121.249l-.37,1.29,3.56-.37v-.92Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7935",
    "data-name": "Path 7935",
    d: "M357.409,112.959l-1.19,1.18-.45,2.92,1.64.4-.37-2.59.96-1.19Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7936",
    "data-name": "Path 7936",
    d: "M365.479,120.739l-.47-2.53-3.9.55Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7937",
    "data-name": "Path 7937",
    d: "M374.489,121.459v-.01l-3.79-1.97-3.53,2.87-3.73-1.47-.42,2.05,2.2-.08,5.44,2.27.98,2.79-1.81,1.1,4.66,1.62",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7938",
    "data-name": "Path 7938",
    d: "M343.709,60.809l2.19,4.75,2.66-.19.45-3.06-3.68-3",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7939",
    "data-name": "Path 7939",
    d: "M345.329,59.309l-1.62-1.33,2.1-.28-.37-4.19V53.5l-.01.01-3.26,2.25-2.13,1.46v.01l1.58,2.99,2.09.59Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7940",
    "data-name": "Path 7940",
    d: "M343.069,110.349v-2.78l-2.44.2-2.92,3.94-6.76,3.12,1.39.84,6.44-1.44,1.92-3.63,2.37-.24Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7941",
    "data-name": "Path 7941",
    d: "M318.249,107.769l1.17,3.81,4.83,4.12.38-1.47-4.56-6.73h-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7942",
    "data-name": "Path 7942",
    d: "M374.489,130.629l1.7.6,3.24-2.98,4.2,4.1,3.83.78-4.75-4.74.23-2.51-8.45-4.42Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7943",
    "data-name": "Path 7943",
    d: "M385.089,126.309l1.7,1.02,2.96-1.66v-1.72Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7944",
    "data-name": "Path 7944",
    d: "M387.469,121.489l3.44,2.47,1.38-.47-3.5-2.09Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7945",
    "data-name": "Path 7945",
    d: "M315.769,86.5v-1.45l-3.7-6.16.95-2.6-2.14-.92h-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_907",
    "data-name": "Line 907",
    y1: 1.53,
    x2: 2.09,
    transform: "translate(1515.669 742.499)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7946",
    "data-name": "Path 7946",
    d: "M306.649,86.779l2.14,1.79.81,4.27,1.51.45,1.08-1.35,2.01,2.26,1.11,4.13-.26,4.25v.02l1.72-3.38",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7947",
    "data-name": "Path 7947",
    d: "M308.009,77.429l-.01.01-1.04,7.21v.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7948",
    "data-name": "Path 7948",
    d: "M317.579,87.559v2.75h.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7949",
    "data-name": "Path 7949",
    d: "M317.629,84.109l-1.86.94h-.01V86.5",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7950",
    "data-name": "Path 7950",
    d: "M327.339,94.689l-5.07-5.39-1.12-3.47",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7951",
    "data-name": "Path 7951",
    d: "M322.139,96.019l2.32-2.33-2.48-3.38h-4.39v-2.75h-.01l-1.81-1.06h-.01l-2.09,1.52v.01l3.1,11.19-1.72,3.36-.01.02-.1,1.68,3.01,2.56.29.93h.01l1.81-.27-2.92-4.31.68-6.67,3.29,3.26",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7952",
    "data-name": "Path 7952",
    d: "M327.339,96.019h-5.2l-1.03,1.03v2.73l1.64,1.63,1.85-.26",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7953",
    "data-name": "Path 7953",
    d: "M326.489,85.389h-.01l-4.23-3.62-4.62,2.34,3.52,1.72,1.13,3.47,5.06,5.39V99.1l-2.74,2.05.07,2.95,5.25-3.47-.18-5.16-5.48-5.8.27-3.17,1.95-1.11",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7954",
    "data-name": "Path 7954",
    d: "M300.839,83.829l1.07-1.03,4.74,3.98.31-2.12-2.49-2.34",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_908",
    "data-name": "Line 908",
    x1: 1.17,
    y2: 0.55,
    transform: "translate(1501.189 734.069)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7955",
    "data-name": "Path 7955",
    d: "M272.549,81.789l.27.32,2.71.86-1.27,1.3,1.2,1.56,2.16.25L278,84.3l.85.01,6.91,19.88,4.39-2.7.68-7.99,10.01-9.67-1.65-5.21v-.01l1.17-.54,1.71,2.28,1.99-.82.41,2.79,2.49,2.33,1.05-7.22,2.86-2.06.01-.01-4.84-2.09-.01.01-3.27,3",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_909",
    "data-name": "Line 909",
    x1: 3.28,
    y2: 0.87,
    transform: "translate(1474.539 736.909)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7956",
    "data-name": "Path 7956",
    d: "M280.239,71.9l-3.8,3.5H274v2.59l1.82.69",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7957",
    "data-name": "Path 7957",
    d: "M277.649,67.489l1.75.99v.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7958",
    "data-name": "Path 7958",
    d: "M287.339,74.049l.02-3.08v-.01l-2.41-.83-.28-5.48",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7959",
    "data-name": "Path 7959",
    d: "M299.2,77h-.01l.4-1.8-.82-.29",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7960",
    "data-name": "Path 7960",
    d: "M298.769,74.909l-11.4-3.95v.01l-.03,3.08,9.67,3.66Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7961",
    "data-name": "Path 7961",
    d: "M299.6,75.2l-.4,1.8,1.34.33,1.53.38.68-1.42.01-.01Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7962",
    "data-name": "Path 7962",
    d: "M254.149,37.069v3.82h-15v4.94l2.01,2.51,4.3-1.73,2.56,1.73-3.11,1.51-.09,2.24,2.05,1.7,2.61-.72,2.31,1.93",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7963",
    "data-name": "Path 7963",
    d: "M287.759,44.869l-3.67-2.14-21.48-7.58-8.46,1.91",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_910",
    "data-name": "Line 910",
    x1: 0.01,
    transform: "translate(1489.759 700.879)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7964",
    "data-name": "Path 7964",
    d: "M282.439,54.689l-1.06-4.94,6.38-4.86v-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7965",
    "data-name": "Path 7965",
    d: "M251.389,49.989l3.56-.83,4.7,3.22,3.93-.75,2.88,3.79,2.77-.12,2.71-2.23,6.4-.28.01.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7966",
    "data-name": "Path 7966",
    d: "M260.159,66.229l-.01-.01,1.1-2.32",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7967",
    "data-name": "Path 7967",
    d: "M264.809,76.569l-1.92-2.4-.32-.93",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7968",
    "data-name": "Path 7968",
    d: "M238.689,58.8v1.65l6.76,11.47,2.01.19,4.66,4.87,8.58,2.56h2.38",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7969",
    "data-name": "Path 7969",
    d: "M250.879,60.889l-.06,1.47h-4.23l-2.33-4.11-2.67.26-1.91.19",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_911",
    "data-name": "Line 911",
    x1: 0.89,
    y1: 1.44,
    transform: "translate(1461.809 717.569)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7970",
    "data-name": "Path 7970",
    d: "M251.789,55.009l-2.31-1.93-2.61.72,4.16,3.45-.15,3.64,3.32-1.1,5.61,1.78h.01l.88,1.44.55.89",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7971",
    "data-name": "Path 7971",
    d: "M262.469,72.959l.1.28.33.93,1.91,2.4-1.73,2.97h7.49l1.97,2.24v.01h.01l3.27-.88v-2.24l-1.82-.68.01-2.58h2.43l3.8-3.5V71.9l-.84-3.41-1.75-1,.08-1.75,2.89-2.05h1.94",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_912",
    "data-name": "Line 912",
    x1: 4.99,
    y2: 4.62,
    transform: "translate(1469.829 724.389)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7972",
    "data-name": "Path 7972",
    d: "M284.669,64.649l-2.1-.96h-.01l-4.05-1.85",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_913",
    "data-name": "Line 913",
    y1: 1.74,
    x2: 0.22,
    transform: "translate(1474.259 711.159)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7973",
    "data-name": "Path 7973",
    d: "M269.469,61.929l-1.31-3.85h.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7974",
    "data-name": "Path 7974",
    d: "M251.389,49.989l.4,5.01v.01l2.27-.9h3.73l8.8,7.05",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7975",
    "data-name": "Path 7975",
    d: "M269.479,61.929h-.01l-2.87-.77h-.01l-5.34,2.74-1.09,2.33,2.31,6.73,5.36.05,4.99-4.61v-.01l1.37-5.93",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7976",
    "data-name": "Path 7976",
    d: "M269.509,57.689l-1.34.39,1.31,3.85,3.83-1.97.88,2.5,4.32-.62-.63-.29-1.26-3.09",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7977",
    "data-name": "Path 7977",
    d: "M282.449,54.7h-.01v-.01l-4.09-1.89-6.41.28-2.7,2.23h-.01l-2.78.12-2.88-3.79-3.92.75-4.7-3.22-3.56.82",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7978",
    "data-name": "Path 7978",
    d: "M269.239,55.309l3.24-.15h.02l-.23,1.74h-.01l-2.75.79,3.44,1.12,3.66-.35h.01l-.57-1.39,6.39-2.37",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_914",
    "data-name": "Line 914",
    x1: 1.99,
    y1: 0.49,
    transform: "translate(1442.399 710.489)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7979",
    "data-name": "Path 7979",
    d: "M241.6,58.519l2.66-.27-1.85-3.26h-.02",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_915",
    "data-name": "Line 915",
    x1: 0.08,
    y2: 0.02,
    transform: "translate(1435.889 708.769)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_916",
    "data-name": "Line 916",
    x1: 0.93,
    y2: 0.2,
    transform: "translate(1436.019 708.559)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7980",
    "data-name": "Path 7980",
    d: "M239.149,56.279l1.25-1.79-4.63-2.1h-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7981",
    "data-name": "Path 7981",
    d: "M233.889,52.8v2.56l3.58.91.05.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7982",
    "data-name": "Path 7982",
    d: "M238.689,58.8l.99-.1,1.92-.18-.01-.01-2.44-2.23h-1.63Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7983",
    "data-name": "Path 7983",
    d: "M207.489,31.439l-.17-.08.01,1.6",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7984",
    "data-name": "Path 7984",
    d: "M210.049,31.179l.24.18-.25,1.16",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7985",
    "data-name": "Path 7985",
    d: "M207.5,33l-.17-.04.01,1.83.13.04",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_917",
    "data-name": "Line 917",
    x1: 0.03,
    y2: 0.02,
    transform: "translate(1412.489 693.769)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7986",
    "data-name": "Path 7986",
    d: "M213.909,28.819l-.02-.14-.02.02-.74.7",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7987",
    "data-name": "Path 7987",
    d: "M209.379,29.479h-.17l-.32.82,1.16.88.12-.03",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7988",
    "data-name": "Path 7988",
    d: "M230.009,44.469l.35-.78-.89-.36",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7989",
    "data-name": "Path 7989",
    d: "M223.429,48.349l-1.09,1.13,1.51.85.15-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_918",
    "data-name": "Line 918",
    y1: 0.01,
    transform: "translate(1420.189 705.329)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_919",
    "data-name": "Line 919",
    x1: 0.04,
    y1: 0.01,
    transform: "translate(1413.209 695.769)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7990",
    "data-name": "Path 7990",
    d: "M195.829,30.419l-.07.11,2.73,3.15.5.57.1-.08",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7991",
    "data-name": "Path 7991",
    d: "M195.429,30.149l.32.38.07-.11",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7992",
    "data-name": "Path 7992",
    d: "M210.289,15.209l-4.87.25-16.71,11.57,1.67,3.92.16-.03",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7993",
    "data-name": "Path 7993",
    d: "M212.759,15.079l-2.47.12v.02",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_920",
    "data-name": "Line 920",
    y1: 0.01,
    transform: "translate(1414.769 671.079)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7994",
    "data-name": "Path 7994",
    d: "M209.329,20.449l-2.67,6.05,3.12,1.58h.17",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7995",
    "data-name": "Path 7995",
    d: "M354.369,44.329h1.64l-5.8-5.93-1.64-.05,4.66,5.75,2.28,4.25h1.69Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7996",
    "data-name": "Path 7996",
    d: "M207.469,34.859l-.17-.06.01,1.35v.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7997",
    "data-name": "Path 7997",
    d: "M217.729,34.239l2.37,3.85-1.37.88,2.28.92h.01l.06.03,8.39,3.41.87.36-.34.76-.96,2.16v.01l.01.03.61,1.43-1.51.41.27,2.4,5.45,1.91h.02v-.01l.08-.01.05-.01.93-.21.8-.17h.01l4.62,2.1h.02l1.99.5v-.01l-1.25-2.18v-4.45l-2.01-2.51V40.9h15v-3.83h.02v-.01l8.44-1.89,21.47,7.57,3.68,2.15.02-.01v-.01l4.52-3.43,6.07,1.85.01-.01,1.63-3.69H300l14.93,3.7h7.32v-.01l2.72-.54v-.01l-1.46-5.15h6.4l6.57,6.44,8.95,2.28v7.21h.01l3.91-.68,2.11-3.15v-5.85l-6.03-6.85-5.84-.09,1-7.21,12.05.09,1.31-4.09,5.08,1.92.02-1.89,1.26.13,2.19,2.1-2.11,1.45-.26,4.31,8.58,8.12v-7.85l-4.84-4.66,11.47-3.63.14-1.17-5.76-1.57,2.24-1.75,5.16,1.06,3.5.07-2.81-3.01-18-3.56-27.9-.8-1.57-2.13-9.73-1.59-2.74,2.46h-7.88l-3.28-2.46H288.9L287.8,7.3h-16.44l-14.49,6.48,3.17,3.93-2.74,2.83-2.47-8.09-4.37-.34,2.1,4.78-16.9.46-15.65,6.42-.15.06-2.08-3.97.17.01,5.83.22.03-.02,2.9-1.44-11.48-3.67-.02-.01-2.44.13h-.01v.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7998",
    "data-name": "Path 7998",
    d: "M212.769,15.089l4.42,9.91-2.67,3.08-.65.6v.02l.02.14.4,2.8v.01l.01.04.35,2.55h.17",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_921",
    "data-name": "Line 921",
    x1: 0.01,
    y2: 0.01,
    transform: "translate(1403.279 703.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_922",
    "data-name": "Line 922",
    x1: 0.02,
    transform: "translate(1394.249 702.159)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7999",
    "data-name": "Path 7999",
    d: "M170.829,54.039l-.17-.03-.14,5.43,1.37,2.42.76.06v-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_923",
    "data-name": "Line 923",
    x2: 0.01,
    y2: 0.01,
    transform: "translate(1402.079 697.379)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_924",
    "data-name": "Line 924",
    x1: 0.01,
    transform: "translate(1401.829 692.629)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8000",
    "data-name": "Path 8000",
    d: "M203.989,35.7l-.04-.03-3.93.96",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8001",
    "data-name": "Path 8001",
    d: "M207.339,36.149h-.03l-2.58.08",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_925",
    "data-name": "Line 925",
    y1: 0.02,
    transform: "translate(1419.459 707.449)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_926",
    "data-name": "Line 926",
    x2: 0.06,
    y2: 0.01,
    transform: "translate(1417.809 707.049)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8002",
    "data-name": "Path 8002",
    d: "M192.619,35.669l.35.86-2.65,1.59",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8003",
    "data-name": "Path 8003",
    d: "M193.449,32.019h-.17l-1.13,2.55.47,1.1h.17",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8004",
    "data-name": "Path 8004",
    d: "M196.339,35.3h.49l.01-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8005",
    "data-name": "Path 8005",
    d: "M196.389,33.6l-.05-.05-.88.36-.28,1.4h.17",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_927",
    "data-name": "Line 927",
    y2: 0.01,
    transform: "translate(1395.699 702.149)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8006",
    "data-name": "Path 8006",
    d: "M197.609,60.049h-.17v.82l1.23.85,2.06.32V62",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8007",
    "data-name": "Path 8007",
    d: "M192.269,55.469l-.17-.05V58.8h1.57v-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8008",
    "data-name": "Path 8008",
    d: "M192.329,50.579h2.2l6.8,6.79.31,2.59.04.3.16-.09",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8009",
    "data-name": "Path 8009",
    d: "M193.059,53.089h-.17v1.39l.78.3.01-.07",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_928",
    "data-name": "Line 928",
    x1: 6.53,
    y2: 3.91,
    transform: "translate(1381.589 696.629)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8010",
    "data-name": "Path 8010",
    d: "M177.359,44.549h-.17v1l2.82,1.53.38,5",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8011",
    "data-name": "Path 8011",
    d: "M187.669,39.7l-1.55.93.08.04",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8012",
    "data-name": "Path 8012",
    d: "M190.309,38.219l.01-.1-2.65,1.58.09.05",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8013",
    "data-name": "Path 8013",
    d: "M177.239,31.5h-.17v3.46l1.95.18.03,2.1-1.44.79,1.27,1.85-2.57,2.43.21-.04",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_929",
    "data-name": "Line 929",
    x1: 0.16,
    y1: 0.01,
    transform: "translate(1375.819 691.119)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8014",
    "data-name": "Path 8014",
    d: "M173.879,35.2l-.06-.08-2.54,1.86v3.74h.17",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8015",
    "data-name": "Path 8015",
    d: "M172.889,39.459l2.57.35v-.02",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8016",
    "data-name": "Path 8016",
    d: "M170.879,52.159h-.17l-.04,1.84.16.03",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8017",
    "data-name": "Path 8017",
    d: "M172.659,61.909v.01l6,.44.01-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8018",
    "data-name": "Path 8018",
    d: "M185.939,57.249v-.14l-1.85,1.61h1.85v-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_930",
    "data-name": "Line 930",
    y2: 0.01,
    transform: "translate(1407.449 704.239)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_931",
    "data-name": "Line 931",
    x2: 0.01,
    transform: "translate(1401.089 705.809)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8019",
    "data-name": "Path 8019",
    d: "M235.579,61.069l3.07-.62V58.8l-1.18-2.52-3.63-.92-14.66.48-.76.91-.5.59-2.83-.02,2.33,4.68,10.71.59,4.75-.97,2.7-.54",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_932",
    "data-name": "Line 932",
    x2: 0.01,
    transform: "translate(1417.239 712.279)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8020",
    "data-name": "Path 8020",
    d: "M203.379,53.249l.94.23.04-.03",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8021",
    "data-name": "Path 8021",
    d: "M206.439,57.309h-.01l1.21,1.39,2.33.65-1.42.6,1.88,2.37.08-.12",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_933",
    "data-name": "Line 933",
    x1: 0.01,
    y1: 0.01,
    transform: "translate(1407.439 704.239)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8022",
    "data-name": "Path 8022",
    d: "M199.909,49.779l2.87,3.32.6.15-.02-.05",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8023",
    "data-name": "Path 8023",
    d: "M204.379,53.449l-.05.04,1.13.28",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8024",
    "data-name": "Path 8024",
    d: "M205.509,53.739l-.05.03.76,3.3.22.24.13-.04",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_934",
    "data-name": "Line 934",
    x1: 0.03,
    y1: 0.01,
    transform: "translate(1417.809 707.049)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8025",
    "data-name": "Path 8025",
    d: "M250,80.319l.76-.78-1.33-1.87-.59,1.88",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8026",
    "data-name": "Path 8026",
    d: "M225.769,63.789l-3.05,1.13,2.18.55Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_935",
    "data-name": "Line 935",
    y1: 0.01,
    transform: "translate(1434.129 723.209)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_936",
    "data-name": "Line 936",
    y1: 0.03,
    x2: 0.07,
    transform: "translate(1434.449 724.849)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_937",
    "data-name": "Line 937",
    y1: 3.08,
    x2: 0.53,
    transform: "translate(1432.589 725.449)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8027",
    "data-name": "Path 8027",
    d: "M250.879,80.9l-.88-.58-1.16-.77-.37-.24-3.02-4.93h-1.32v-.01l-.94-1.22",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8028",
    "data-name": "Path 8028",
    d: "M256,83.639l-1.7-.24-.81-.11",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_938",
    "data-name": "Line 938",
    y1: 2.8,
    x2: 5.35,
    transform: "translate(1445.119 745.579)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8029",
    "data-name": "Path 8029",
    d: "M232.539,68.929l-.09-.05-1.33.57h-.01l-.52,3.08-1.72.8-1.14-.14,10.64,18.49.22.69",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8030",
    "data-name": "Path 8030",
    d: "M242,73.149h1.2l.93,1.22h1.32l-1.6-2.6h-1.51",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8031",
    "data-name": "Path 8031",
    d: "M234.359,65.879l-2.23,1.34.39,1.63.02.08,8.07,4.21,1.39.01.34-1.38,2.97-.01-6.66-11.3-3.07.62",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8032",
    "data-name": "Path 8032",
    d: "M257.429,80.209,256,78.929l-2.26,2.54-2.86-.57,1.19,2.19,1.42.2.8.12",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8033",
    "data-name": "Path 8033",
    d: "M252.209,90.849l2.11,1.43,6.97-8.64-3.86-3.43L254.3,83.4l-.01.01,1.71.23v3.92l-3.79,1.02",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8034",
    "data-name": "Path 8034",
    d: "M227.729,67.7l1.65,1.15,2.75-1.64,2.23-1.33,1.22-4.8v-.01l-2.7.55-4.76.98-.5,2.33",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8035",
    "data-name": "Path 8035",
    d: "M248.469,89.579l-5.35,2.81v-.01l.35-1.43-3.78-.48-1.1,1.9,1.88,6.16,13.85-6.24-2.11-1.44v-2.27Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8036",
    "data-name": "Path 8036",
    d: "M227.729,67.7l1.24-2.3-1.35-.47-.49,2.33Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8037",
    "data-name": "Path 8037",
    d: "M227.7,73.259l.03-.07V67.7l-.6-.43-.95,3.51",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8038",
    "data-name": "Path 8038",
    d: "M239.079,151.629l1.44,3.42,3.47.15,5.89-18.9h-2.1l-6.85,7.11-.68,4.93Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_939",
    "data-name": "Line 939",
    y1: 3.65,
    x2: 0.91,
    transform: "translate(1402.119 761.189)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_940",
    "data-name": "Line 940",
    x1: 0.01,
    y1: 0.01,
    transform: "translate(1404.669 768.439)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8039",
    "data-name": "Path 8039",
    d: "M202.3,113.549h.01l.38-1.1",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8040",
    "data-name": "Path 8040",
    d: "M192.9,107.419l-.43,3.03h1.34l-.06,3.1",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8041",
    "data-name": "Path 8041",
    d: "M199.559,96.969v2.91l-3.56,7.36",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_941",
    "data-name": "Line 941",
    x1: 1,
    y1: 2.95,
    transform: "translate(1402.029 758.229)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_942",
    "data-name": "Line 942",
    x1: 2.55,
    transform: "translate(1398.089 769.549)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8042",
    "data-name": "Path 8042",
    d: "M193.689,115.8l-.08,3.68,3.09,4.13",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8043",
    "data-name": "Path 8043",
    d: "M193.689,115.8h2.4v-2.25h-2.34Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_943",
    "data-name": "Line 943",
    x1: 0.12,
    y2: 0.6,
    transform: "translate(1387.699 754.989)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8044",
    "data-name": "Path 8044",
    d: "M186.249,96.969h-.01l-.41,2.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8045",
    "data-name": "Path 8045",
    d: "M184.079,107.449l3.98.58.54,2.42h3.86l.44-3.03,3.1-.18,3.55-7.36v-2.91",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_944",
    "data-name": "Line 944",
    x1: 3.53,
    y1: 0.69,
    transform: "translate(1371.569 757.499)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8046",
    "data-name": "Path 8046",
    d: "M169.4,111.679v.01l7.24-2.1",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8047",
    "data-name": "Path 8047",
    d: "M166.779,104.159l-2.32,2.19,4.94,5.33v-4.56l-.98-1.1",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8048",
    "data-name": "Path 8048",
    d: "M199.109,126.809v9.98l-2.56,4.2.23,2.74",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8049",
    "data-name": "Path 8049",
    d: "M204.139,128.739l-.56-1.96h-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8050",
    "data-name": "Path 8050",
    d: "M210.519,131.759v-4.55H207.7l-.57,2h-.01l-2.81.1v-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8051",
    "data-name": "Path 8051",
    d: "M176.639,102.889v6.7l4.92-1.42",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8052",
    "data-name": "Path 8052",
    d: "M206.629,112.449h-3.95l-.38,1.1h-3.66l2.02,6.53H196.7v3.53l1.55,2.07,3.78-1.72v-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_945",
    "data-name": "Line 945",
    x1: 5.93,
    y1: 10.18,
    transform: "translate(1434.849 744.209)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8053",
    "data-name": "Path 8053",
    d: "M162.1,103.809l2.36,2.54,2.32-2.18",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_946",
    "data-name": "Line 946",
    x2: 1.51,
    y2: 1.67,
    transform: "translate(1438.999 755.879)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8054",
    "data-name": "Path 8054",
    d: "M240,100.479l-.73-1.25-.49-.84-.89.75",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_947",
    "data-name": "Line 947",
    x1: 0.01,
    transform: "translate(1429.499 790.769)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8055",
    "data-name": "Path 8055",
    d: "M223.559,156.409l1.56-.03.1-.76,3.24-2.26-.24-6.81,7.6-6.24-.75-7.11",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8056",
    "data-name": "Path 8056",
    d: "M223.559,150.8v5.08",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8057",
    "data-name": "Path 8057",
    d: "M227.6,139.389v-.01l-1.83-1.5-.05.04",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8058",
    "data-name": "Path 8058",
    d: "M236.639,113.229v6.82l14.75-17.16-.6-3.01-10.25,1.52-.54-.92-1.49,1.07,1.51,1.7",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8059",
    "data-name": "Path 8059",
    d: "M212.549,143.729h-15.78l5.63,15.85h5.66v-5.17",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_948",
    "data-name": "Line 948",
    x1: 0.98,
    y1: 1.36,
    transform: "translate(1416.599 799.729)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8060",
    "data-name": "Path 8060",
    d: "M227.079,118.289l7.07,4.66,2.48-2.9v-6.82h.01l2.73-2.28",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8061",
    "data-name": "Path 8061",
    d: "M228.239,116.239v.01l-1.16,2.03",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_949",
    "data-name": "Line 949",
    x1: 2.58,
    y2: 0.36,
    transform: "translate(1429.859 765.999)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8062",
    "data-name": "Path 8062",
    d: "M227.5,131.039h.01v3.73l7.56-1.57h.01l-.93-10.25-7.07-4.67v.01l-.44.77h-2.55l.66-1.13",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_950",
    "data-name": "Line 950",
    x1: 1.54,
    y2: 3.83,
    transform: "translate(1422.989 776.549)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8063",
    "data-name": "Path 8063",
    d: "M169.159,75.729h-.01v2.15",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8064",
    "data-name": "Path 8064",
    d: "M172.039,92.679l-.7-12.35h4.04l-6.22-4.59",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8065",
    "data-name": "Path 8065",
    d: "M164.4,93.419v-.01h7.68",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8066",
    "data-name": "Path 8066",
    d: "M158.219,85.049h-.01l-.18,5.42",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8067",
    "data-name": "Path 8067",
    d: "M164.959,77.879h-.01v4.83l-1.55,2.34",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_951",
    "data-name": "Line 951",
    x1: 0.71,
    y2: 3.02,
    transform: "translate(1422.639 773.929)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_952",
    "data-name": "Line 952",
    y1: 2.62,
    x2: 1.05,
    transform: "translate(1424.539 773.929)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8068",
    "data-name": "Path 8068",
    d: "M220.989,124.379l1.55-3.83h-.01l-1.89.4-.52,2.19",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_953",
    "data-name": "Line 953",
    x1: 2.87,
    transform: "translate(1368.139 754.989)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8069",
    "data-name": "Path 8069",
    d: "M159.639,101.149l2.46,2.66,2.3-2.31,2.38,2.66v.01l1.64,1.85,1.15-1v-3.53",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8070",
    "data-name": "Path 8070",
    d: "M186.689,88.659l-11.3-8.32h-4.04l.69,12.34.04.73v.01H164.4v1.64",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_954",
    "data-name": "Line 954",
    y1: 5.5,
    x2: 13.59,
    transform: "translate(1375.099 749.139)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8071",
    "data-name": "Path 8071",
    d: "M166.139,98.979h2.87v.01l.56,2.5,3.53.7",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8072",
    "data-name": "Path 8072",
    d: "M225.719,131.039l-1.05-1.47-4.56.69-.82,3.69",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_955",
    "data-name": "Line 955",
    y1: 2.41,
    x2: 3.46,
    transform: "translate(1424.259 793.919)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8073",
    "data-name": "Path 8073",
    d: "M213.019,133l.1,3.97h-3.15v3.56l2.58,3.2h2.05",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8074",
    "data-name": "Path 8074",
    d: "M222.019,135.049h.01l-.96,1.92",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8075",
    "data-name": "Path 8075",
    d: "M218,148.5l-2.42-3.41h-7.52v9.32l2.28,2.63,9.3-6.23v-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8076",
    "data-name": "Path 8076",
    d: "M184.729,99.389l-4.14-3.77h-.01l-7.48,3.02v3.55l3.54.7v-1.9h3.75",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8077",
    "data-name": "Path 8077",
    d: "M225.719,131.039v6.88l.05-.03,1.83,1.5v3.2l1.83-1.6v-2.74l-1.93-1.28v-5.93Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8078",
    "data-name": "Path 8078",
    d: "M230.429,109.989l.01.01.91.95h8.03l6.67-5.56-6.03-2.14L237,99.879l.89-.74-2.34-3.7h-5.76l-4.07,9.62",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8079",
    "data-name": "Path 8079",
    d: "M221.349,117.929h3.4l.97-1.69h2.52l.36-2.7-.74-3.18-4.87.68",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8080",
    "data-name": "Path 8080",
    d: "M185.829,98.979l.42-2.01h13.3l3-6.16",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8081",
    "data-name": "Path 8081",
    d: "M184.729,99.389h.01l1.08-.4h.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8082",
    "data-name": "Path 8082",
    d: "M186.689,88.659v4.48l-6.1,2.48,4.14,3.76",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8083",
    "data-name": "Path 8083",
    d: "M169.159,74.959h-4.63l-6.24,8.13-.07,1.96h5.18l1.56-2.34v-4.83h4.2v-2.15",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8084",
    "data-name": "Path 8084",
    d: "M161.709,98.989h4.43v-.01l-1.74-3.92-6.37-4.59-.19,5.28",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8085",
    "data-name": "Path 8085",
    d: "M157.8,96.969l-.08,2.02h.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8086",
    "data-name": "Path 8086",
    d: "M157.8,96.969h4.23l-4.19-1.22Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8087",
    "data-name": "Path 8087",
    d: "M201.369,82.709l1.18,8.1-2.99,6.16,2.47,5.26h-2.01l1,2.96h.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8088",
    "data-name": "Path 8088",
    d: "M210.959,95.389l2.21-2.18V93.2",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_956",
    "data-name": "Line 956",
    y1: 3.76,
    x2: 7.97,
    transform: "translate(1404.989 756.499)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_957",
    "data-name": "Line 957",
    y1: 0.01,
    x2: 0.01,
    transform: "translate(1415.589 739.629)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8089",
    "data-name": "Path 8089",
    d: "M195.609,82.709h9.16l8.62,5.53",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_958",
    "data-name": "Line 958",
    x1: 3.61,
    y2: 3.88,
    transform: "translate(1395.259 723.549)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8090",
    "data-name": "Path 8090",
    d: "M214.239,69.159l-5.02-.68-2.08,3.1-4.57-.91-1.81-2.2-3.88-.93v.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8091",
    "data-name": "Path 8091",
    d: "M179.569,64.579v-.01l-.5.05-7.17.75-7.37,9.59,3.9-.01h.73",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8092",
    "data-name": "Path 8092",
    d: "M169.159,74.339v-.01l10.41-5.68",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8093",
    "data-name": "Path 8093",
    d: "M191.329,62.149l-5.03-.14-6.73,2.57v4.07l-10.41,5.69v1.39l17.53,12.93,8.77-5.95h.15l-2.35-11.28",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8094",
    "data-name": "Path 8094",
    d: "M191.329,62.149l1.93,9.28,3.62-3.88h-.01l-1.41-.34.17-4.94Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8095",
    "data-name": "Path 8095",
    d: "M214.6,143.729l.97,1.36L218,148.5l1.64,2.3h3.92l2.16-5.05v-3.16l-3.46-2.26-4.89,3.4Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8096",
    "data-name": "Path 8096",
    d: "M216.909,163h2.01l1.19-1.24v-1.59h-1.64l-1.56,1V163Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8097",
    "data-name": "Path 8097",
    d: "M223.559,155.879h-1.53v1.4l1.53.92v-2.32Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8098",
    "data-name": "Path 8098",
    d: "M229.319,82.129,223.9,72.8l2.97,2.42.8-1.89.03-.07-1.52-2.48-11.94-1.63v.01l-.64,14.47h13.09Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8099",
    "data-name": "Path 8099",
    d: "M222.989,111.039l7.44-1.05-4.71-4.93-.01-.01,4.08-9.61v-.01l3.06-7.22V88.2l-3.53-6.07-2.63,1.51h-13.1l-.2,4.6-.22,4.96-2.21,2.18v5.11",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8100",
    "data-name": "Path 8100",
    d: "M210.959,100.5l7.82,9,.01.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8101",
    "data-name": "Path 8101",
    d: "M206.969,109.839h-.01l-.33,2.6v.01l-.63,4.91-3.97,6.59-3.78,1.73.85,1.13h.01l4.46-.03.57,1.96.17.56,2.81-.09.57-2.01h2.82v4.56h.01l2.5,1.24,8.05,3.97.95-1.92-2.73-1.1h-.01l.83-3.69v-.01l4.56-.68-3.68-5.19-.87-1.24-.01-.01,1.24-5.2,1.64-6.89-4.2-1.53-11.49.32",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8102",
    "data-name": "Path 8102",
    d: "M201.029,105.189l-.92,3.64.01.01,2.55,3.6h3.97l.33-2.6.33-.01,11.48-.33h.02l-7.84-9v-.01l-7.97,3.77-1.96.92Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8103",
    "data-name": "Path 8103",
    d: "M183.339,107.659l.74-.21,1.62-7.86.13-.6v-.01l-.01.01-1.09.39v.01l-2.61.96",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8104",
    "data-name": "Path 8104",
    d: "M182.119,100.349l-1.73.64,1.17,7.18,1.78-.51Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8105",
    "data-name": "Path 8105",
    d: "M159.639,101.149l2.07-2.16h-3.98l-.01.09Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8106",
    "data-name": "Path 8106",
    d: "M10.4,20.139h-.01l-1.4,1.96H9l6.23-.23-.03.01-7.99,3.01H7.2l-3.89,5.26h.01l3.33-.06-.02.01-6.38,4.19",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8107",
    "data-name": "Path 8107",
    d: "M17.8,17.309h-.01v2.92",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_959",
    "data-name": "Line 959",
    x1: 3.05,
    y1: 1.27,
    transform: "translate(1242.629 670.569)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8108",
    "data-name": "Path 8108",
    d: "M43.719,15.849h-.01l-.01-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_960",
    "data-name": "Line 960",
    x2: 0.3,
    y2: 2.32,
    transform: "translate(1259.829 746.469)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8109",
    "data-name": "Path 8109",
    d: "M59.839,90.159h-2.05v.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8110",
    "data-name": "Path 8110",
    d: "M54.649,94.839l3.34,1.68,2.3-4.15",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8111",
    "data-name": "Path 8111",
    d: "M55.739,92.789h-.01L54.6,94.8l-.01.01.01.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_961",
    "data-name": "Line 961",
    x1: 0.71,
    y2: 1.25,
    transform: "translate(1261.139 749.209)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_962",
    "data-name": "Line 962",
    x2: 0.61,
    y2: 0.27,
    transform: "translate(1262.399 753.609)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8112",
    "data-name": "Path 8112",
    d: "M58.719,95.229l-.73,1.29.01.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_963",
    "data-name": "Line 963",
    x1: 1.44,
    y1: 0.65,
    transform: "translate(1260.719 751.219)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_964",
    "data-name": "Line 964",
    y1: 1.45,
    x2: 0.41,
    transform: "translate(1262.389 752.149)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8113",
    "data-name": "Path 8113",
    d: "M59.839,90.159v.01l.01.03.44,2.17.01-.01,2.15-4.06",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8114",
    "data-name": "Path 8114",
    d: "M61.739,97.269l-.73.61v.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8115",
    "data-name": "Path 8115",
    d: "M63.169,100.789l3.69.39-.18-8.04",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8116",
    "data-name": "Path 8116",
    d: "M72.039,114.879l-2.61,3.29-.31,5.02",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8117",
    "data-name": "Path 8117",
    d: "M72.129,124.639h.01l5.39-6.61.01-.01-5.13-2.93",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8118",
    "data-name": "Path 8118",
    d: "M82.719,106.929h-.01l-2.08-2.3-.37-4.48",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8119",
    "data-name": "Path 8119",
    d: "M84.579,122.049h.01V114l2.91-.19v-6.39",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8120",
    "data-name": "Path 8120",
    d: "M74.409,108.739l-.6,3.89-1.78,2.25h.01l.37.21,5.11,2.93h.02l7.04,4.02",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8121",
    "data-name": "Path 8121",
    d: "M74.519,105.239l.08.25-.82,1.14v.01l.44,1.47",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8122",
    "data-name": "Path 8122",
    d: "M74.159,103.989h-.01l.35,1.17",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8123",
    "data-name": "Path 8123",
    d: "M80.229,99.779v-.01l-1.47-.01-3.05,4.13",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8124",
    "data-name": "Path 8124",
    d: "M100.159,197.409l1.87,1.72,5.77.21-6.22-3.25Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8125",
    "data-name": "Path 8125",
    d: "M90.049,150.5l-1.55,14.38,3.26,14.24,2.94,5.24.14,3.93,4.37,6.69,1.59.17-.82-17.13,9.27-4.01-4.2-5.85",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8126",
    "data-name": "Path 8126",
    d: "M96.209,149.789l-.39.71h-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8127",
    "data-name": "Path 8127",
    d: "M103.119,157.479v-3.01h-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_965",
    "data-name": "Line 965",
    x1: 2.51,
    y2: 1.52,
    transform: "translate(1308.509 811.959)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8128",
    "data-name": "Path 8128",
    d: "M105.049,161.719l4.09-4.2-.11-1.57h-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8129",
    "data-name": "Path 8129",
    d: "M105.049,161.729v6.43l5,1.84,2-3.48-7-4.8",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8130",
    "data-name": "Path 8130",
    d: "M96.269,110.029l1.24-6.07v-.02l-1.4-1.34-5.58-.55-3.1-2.21-7.2-.06.03.37.38,4.48,2.08,2.3,4.78.49h.01v6.39",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8131",
    "data-name": "Path 8131",
    d: "M92.349,114.929h.01l-.25-3.37,4.15-1.53",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8132",
    "data-name": "Path 8132",
    d: "M88.269,113.759h.01l.97,2.17",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8133",
    "data-name": "Path 8133",
    d: "M66.889,102.339h-.01l-.03-1.15",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_966",
    "data-name": "Line 966",
    y1: 1.49,
    x2: 1.14,
    transform: "translate(1268.519 758.939)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_967",
    "data-name": "Line 967",
    y1: 0.01,
    transform: "translate(1268.509 760.429)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8134",
    "data-name": "Path 8134",
    d: "M63.169,100.8h-.01l2.46,3.32",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8135",
    "data-name": "Path 8135",
    d: "M98.059,109.609l-.24,4.96,4.16-.47v-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_968",
    "data-name": "Line 968",
    y1: 0.66,
    x2: 1.8,
    transform: "translate(1298.269 765.369)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8136",
    "data-name": "Path 8136",
    d: "M101.839,108.079l-4.33-4.12-.02-.02-1.23,6.09",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8137",
    "data-name": "Path 8137",
    d: "M98.049,146.389l.01-.01,4.34-.02",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8138",
    "data-name": "Path 8138",
    d: "M90.039,150.5h5.77l.39-.71",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_969",
    "data-name": "Line 969",
    y2: 0.01,
    transform: "translate(1288.839 790.349)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8139",
    "data-name": "Path 8139",
    d: "M109.329,111.029l-1.1-2.4-2.33-.2",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_970",
    "data-name": "Line 970",
    y1: 0.32,
    x2: 2.79,
    transform: "translate(1307.719 769.369)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8140",
    "data-name": "Path 8140",
    d: "M102.4,146.359l-4.35.03-1.85,3.4h.01l6.9,4.68v3.01h3.4l2.51-1.53",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8141",
    "data-name": "Path 8141",
    d: "M101.979,114.089l1.7-.18,2.04-.22v-.01l.18-5.25-4.06-.36v.01l-1.28,2.37Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8142",
    "data-name": "Path 8142",
    d: "M80.839,123.969l-1.65,5.38,6.26,5.39,1.39-.39,4.25-1.2,3.81,3.91,7.4,6.05.1,3.25.12,3.83,6.33,3.37.17,2.39v.01l.11,1.56-4.09,4.2h.01v.01l7,4.79,4.08-7.12.96-6.17,9.92-4.39,1.84-13.71,4.28-5.6v-3.38l-7-4.55-6.85-.42.18-1.87-3.16-1.37-3.17,1.85,1.03-2.77-2.1-.91-2.98,2.3,2.17-3.2-1.92-4.18-.82,2.34-2.79.31-2.04.23-1.7.19-4.15.46.23-4.95.01-.24v-.01l-1.8.67h-.01l-4.17,1.53.26,3.37-3.1,1h-.01l-.97-2.17-.76.05H87.5l-2.91.2h-.01v8.04",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8143",
    "data-name": "Path 8143",
    d: "M74.179,103.989l-.43-1.57v-.01l-3.29.29-1.17.97",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8144",
    "data-name": "Path 8144",
    d: "M73.779,106.619l.81-1.14-.07-.24-.02-.08-.29-1.08-.02-.09",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8145",
    "data-name": "Path 8145",
    d: "M70.169,105.739l.89-1.32,2.1.2v.01l.61,2.01.01-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8146",
    "data-name": "Path 8146",
    d: "M67.749,102.819l-.09.12-1.15,1.49h.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8147",
    "data-name": "Path 8147",
    d: "M86.839,144.059v-9.7l-1.4.39-6.26-5.39,1.66-5.39,3.74-.46v-1.46l-7.05-4.02-.01-.01-5.39,6.62-3.01-1.45h-.01l-.1,1.55,9.18,15.64,7.94,5.32",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8148",
    "data-name": "Path 8148",
    d: "M86.129,145.7l1.33,32.54,3.51,2.84.17,5.83,6.09,7.88,1.97.2-4.37-6.7-.14-3.93-2.94-5.23-3.26-14.25,1.55-14.37v-.01l-3.2-6.44Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8149",
    "data-name": "Path 8149",
    d: "M83.359,89.779l1.38-1.03h2.21l.54-.79.01-.01-4.14-.46",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_971",
    "data-name": "Line 971",
    x2: 3.25,
    transform: "translate(1282.109 745.219)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8150",
    "data-name": "Path 8150",
    d: "M83.359,87.5v-.01h-2.59l.01.01.83,1.19",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8151",
    "data-name": "Path 8151",
    d: "M86.1,50.839h1.51l-2.11,1.44H84Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8152",
    "data-name": "Path 8152",
    d: "M54.629,94.829l-.03-.01.01-.01,1.13-2.02h2.4l-.31-2.32-.04-.3h2.06",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8153",
    "data-name": "Path 8153",
    d: "M58.819,95.049l.32-.59,1.16-2.08",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_972",
    "data-name": "Line 972",
    y1: 1.3,
    x2: 0.72,
    transform: "translate(1259.999 751.229)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8154",
    "data-name": "Path 8154",
    d: "M58,96.529l2.39,1.07.01.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8155",
    "data-name": "Path 8155",
    d: "M60.3,92.379v-.02l-.44-2.16-.01-.03",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_973",
    "data-name": "Line 973",
    x1: 2.66,
    y2: 1.98,
    transform: "translate(1261.849 744.189)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8156",
    "data-name": "Path 8156",
    d: "M62.459,88.289l.05-.1.01-.01v-.01l-2.68,1.99",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_974",
    "data-name": "Line 974",
    y1: 4.08,
    x2: 2.15,
    transform: "translate(1262.299 744.299)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8157",
    "data-name": "Path 8157",
    d: "M60.4,97.609l.41-1.46H60.8l-.64-.28-1.44-.64",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_975",
    "data-name": "Line 975",
    x2: 0.61,
    y2: 0.28,
    transform: "translate(1262.399 753.609)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8158",
    "data-name": "Path 8158",
    d: "M61.009,97.889l.73-.62,4.94-4.13",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_976",
    "data-name": "Line 976",
    x1: 0.19,
    y1: 8.05,
    transform: "translate(1268.679 749.139)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8159",
    "data-name": "Path 8159",
    d: "M61.009,97.889l2.16,2.9v.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8160",
    "data-name": "Path 8160",
    d: "M66.679,93.139l-6.83.07-1.03,1.84-.1.17v.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8161",
    "data-name": "Path 8161",
    d: "M73.789,106.649l.43,1.46.19.63",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8162",
    "data-name": "Path 8162",
    d: "M75.719,103.889h-.01l-1.52.1h-.03l.34,1.17.1.33",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8163",
    "data-name": "Path 8163",
    d: "M66.509,104.439l-.88-.31-.01-.01-2.45-3.32,3.68.39h.02l.02,1.15.86.48.01.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8164",
    "data-name": "Path 8164",
    d: "M66.519,104.439v-.01l1.24-1.6",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8165",
    "data-name": "Path 8165",
    d: "M66.519,104.439l3.65,1.3.02.01.88-1.32,2.09.2h.01l.61,1.99v.01l.01.02.81-1.16-.38-1.4-.03-.1-.43-1.57h-.01l-3.28.29-1.17.97-.01-.01-1.53-.84",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8166",
    "data-name": "Path 8166",
    d: "M83.359,87.5l4.13.46h.02l-.55.8h-2.21l-1.39,1.03v-.56",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8167",
    "data-name": "Path 8167",
    d: "M83.359,87.5v1.73h-3.25v-.54h1.51l-.84-1.19Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8168",
    "data-name": "Path 8168",
    d: "M82.339,53.419l-2.13,1.47h-2.59l.01-.01,2.12-1.46h2.59Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8169",
    "data-name": "Path 8169",
    d: "M110.819,45.9h8.06l-1.68-2.67h-.01l-.02-.01-1.48-.35v-1.92l-.01.01-.04.04-4.78,4.86Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8170",
    "data-name": "Path 8170",
    d: "M57.989,96.529l-3.34-1.68v-.01l1.13-2.01h2.4l-.34-2.63H59.9l2.55-1.9.01-.01.11-.08.11-2.9-2.93-.06-2.32,3.82-6.39.01v-.01l-3.11-6.69",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8171",
    "data-name": "Path 8171",
    d: "M27.659,68.349l.02.02.59,6.25,4.27,8.08,1.75-1.35-3.37-7.18v-4.04h1.99l.07,3.76,6.38,14.98,10.4,4.34,2.6-.69L54.6,94.8l.01.01.02.02.02.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8172",
    "data-name": "Path 8172",
    d: "M42.269,71.249l-.73-1.11h-.01l-13.88-1.8v.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8173",
    "data-name": "Path 8173",
    d: "M127.979,4.819l-5.72,1.76V8.5l9.45.13h.14l2.45,4.24.01.01v3.83h-.01l-4.59,2.62.13,5.2,2.89,2.91.01.01h3.41l5.23-5.52,7.37-2.18,2.76-2.11,5.57-.35h.01l3.89-1.15h.01l7.36-11.7,4.52-.93h.01l1.6-1.6h-.02L162.719.719l-1.31-.13h-.01l-11.28,1.32h-13.69l-7.88,2.74Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8174",
    "data-name": "Path 8174",
    d: "M43.7,15.839l-3.07-1.27-16.26.09-6.57,2.65v2.92h-.01l-7.39-.09L9,22.1l6.2-.22h.04l-8.03,3.01-3.89,5.26,3.31-.05h.03l-6.41,4.19,2.34.19,12.24-5.85,14.12-.49,4.28,4.27.02.02,1.62-1.74-1.42-1.47h-1.6l-1.56-1.78,13.42-11.59.01-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_977",
    "data-name": "Line 977",
    y2: 0.01,
    transform: "translate(1245.719 671.839)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_978",
    "data-name": "Line 978",
    x2: 0.01,
    transform: "translate(1245.719 671.849)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8175",
    "data-name": "Path 8175",
    d: "M33.089,43.029l-2.23-1.83-.96.82,1.56,2.04h1.63Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8176",
    "data-name": "Path 8176",
    d: "M110.859,45.859h7.97l-1.66-2.63v-.01l-.02-.03-1.46-.35h-.01l-.04-.01v-1.92l-4.88,4.95h.1Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8177",
    "data-name": "Path 8177",
    d: "M104.049,22.739h2.7l3.87,3.2,1.06-.46-.92-2.03,2.66,1.26.87-.37v-3.98l3.06,1.09,1.76-1.17-.99-1.86-1.77-.64-.08-2.81-9.81-4.01-1.46-.02-3.41,2.8,1.14-2.82-1.65-.01-3.98,4.22,2.06-.11,7.6-.41,5.89,5.27-3.96-.06-2,1.63h-4.5v1.29Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8178",
    "data-name": "Path 8178",
    d: "M71.4,45.839l6.57-1.39.82,2.91,1.33.98,2.23-.16.87,2.62h2.83l1.96-1.35h6.35l2.74-2.37h2.46l-.01.04-.01.01-.87,2.76.06-.01h.01l4.31-.75-2.87,1.37.27,1.19,7.81-2.74-3.81-.18-1.78-1.6,1.76-2.73-.86-.82-5.52,2.5v-1.44l5.28-2.54,8.47-.36,6.36-3.39.03-1.54-4.63-.8-.57-7.58-6.06,2.39.04-3.57-2.92-2.49h-3.98l-10.74,15.64h-2.6l.05-5.14-9.25-5.02,9.25-6.85,5.25-.96-1.1-1.62,8.08-.89,3.29-3.42-3.08-.35L94.969,19l.48-2.4-1.98-.2L93,13.5l-3.44,1.52.9,1.85-4.6,2.19-8.01-1.5-4.23,1.98-10.29-4.11-19.61.41h-.04l-13.43,11.6,1.56,1.79h1.6l1.42,1.46-1.6,1.72-.02.03-1.65,7.52,2.95,2.67v1.44h33.01Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8179",
    "data-name": "Path 8179",
    d: "M95.069,21.449l-2.52,2.05,4.98.53.53-1.29Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8180",
    "data-name": "Path 8180",
    d: "M85.359,16.249l.92,1.2,2.35-1.2-.7-1.11Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8181",
    "data-name": "Path 8181",
    d: "M87.139,12.229l1.5,1.51,3.21-1.07.84-2.25Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8182",
    "data-name": "Path 8182",
    d: "M93.269,11.329l.41,1.43,4.38-1.16-.89-1.17Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8183",
    "data-name": "Path 8183",
    d: "M104.429,8.349l-2.4-1L99.7,9.339l9.45.74,2.47-1.73Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8184",
    "data-name": "Path 8184",
    d: "M127.439,3.039l4.93-2.79-19.58,1.46v1.05l6.61-.13-.93,1.23-6.85.14.89,1.57-2.95-.48,1.17,1.51h-5.07l.76.75h5.54l.89.76,8.08-3.77Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8185",
    "data-name": "Path 8185",
    d: "M103.469,4.179l3.65.69,2.09-1.34L107.7,2.4Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8186",
    "data-name": "Path 8186",
    d: "M64.939,13.749l8.57-2.92-1.97-.91-8.1,2.06Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8187",
    "data-name": "Path 8187",
    d: "M74.619,11.369,70,12.939l2.72,1.14-4.25,1.09,5.28,2.05,3.63-1.58,4.04.96,3.03-.7-2.96-1.36,2.28-2.95h-2.28l-1.37,1.78-.55-1.78-2.42.94Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_979",
    "data-name": "Line 979",
    x1: 0.01,
    transform: "translate(1282.109 743.219)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8188",
    "data-name": "Path 8188",
    d: "M67.919,83.519h4.21l3.4,2.26-1.3,1.44h5.88l-7.03-5.07h-3.72Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8189",
    "data-name": "Path 8189",
    d: "M73.819,89.819l.88.75h2.54v-.89l-.89-.89h-2.53Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8190",
    "data-name": "Path 8190",
    d: "M89.419,89.119l-.52.85h1.42l.52-.85Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8191",
    "data-name": "Path 8191",
    d: "M394.889,177.269l-.85,2.72,6.21-4.42-1.79-2.38v-2.72l-1.02.42v3.83Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8192",
    "data-name": "Path 8192",
    d: "M378.559,186.2l12.93-6.55v1.7l-9.95,6.55Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8193",
    "data-name": "Path 8193",
    d: "M325.569,152.6l10.89-5.1,8.08-8.93,4.42,1.96,1.96-4.08,7.4-.17-1.87,3.4,6.12,5.27,4.08-4.08v-5.7l1.88.59,2.12,10.21,6.64,9.35-.68,7.06-12.08,12.5-10.46-.6-1.28-7.06-3.57,1.53-3.4-2.97-20.67,4.52-1.28-1.53,1.7-4.09Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8194",
    "data-name": "Path 8194",
    d: "M200.559,64.839l.17.04.01-1.82h-.17l-1.9-.06-.02,1.35Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8195",
    "data-name": "Path 8195",
    d: "M214.3,31.689l-1.17.35-.05-.03h-.01l-1.9-1.06",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_980",
    "data-name": "Line 980",
    x1: 0.37,
    y1: 2.6,
    transform: "translate(1416.469 687.639)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8196",
    "data-name": "Path 8196",
    d: "M210.209,31.179l.25.18-.27,1.23-.15-.07-2.55-1.16v.08l.01,1.52",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8197",
    "data-name": "Path 8197",
    d: "M213.809,35.109l-.1-.05h-.01l-2.53-1.16-3.67-.94V33l.01,1.79,2.05.68.56,1.16.4,1.14.04.1",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_981",
    "data-name": "Line 981",
    x1: 2.27,
    y1: 0.93,
    transform: "translate(1420.919 694.959)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8198",
    "data-name": "Path 8198",
    d: "M214.839,34.239l-1.03.87-3.25,2.76.68,1.88,6.04.96h.02l.07.01,3.71-.8",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8199",
    "data-name": "Path 8199",
    d: "M220.119,38.189l.17-.1-2.37-3.85h-.02",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8200",
    "data-name": "Path 8200",
    d: "M209.379,29.479l-.32.82,1.11.85.04.03.85-.2.11-.03,1.89,1.06h.01v.01l.06.03,1.17-.36h.01l.15-.05h.01l-.41-2.96-.02.02-.13.12-.02.02-.6.56h-.16Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8201",
    "data-name": "Path 8201",
    d: "M221.179,39.889l-.09.02-.01.01-3.71.81-.09-.01v-.01h-.03l-6.01-.96.01.03.37,1.03-2.2,2.74V45.1",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8202",
    "data-name": "Path 8202",
    d: "M229.209,46.609h.02l.87-1.96.43-.96-1.11-.45-8.22-3.35h-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8203",
    "data-name": "Path 8203",
    d: "M217.119,48.889l1.07.44.15.06.34-1.04h4.92l-1.09,1.13,1.49.84.02.01,2.04-.16-1.93-2.47,4.92-1.05.16-.03",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8204",
    "data-name": "Path 8204",
    d: "M210.409,45.1h7.31l.8,1.51-1.44,2.26",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_982",
    "data-name": "Line 982",
    x1: 0.76,
    y1: 1.84,
    transform: "translate(1409.099 672.779)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_983",
    "data-name": "Line 983",
    x1: 0.03,
    y1: 0.06,
    transform: "translate(1410.589 676.389)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8205",
    "data-name": "Path 8205",
    d: "M195.919,30.529l3.17,3.64.07.08,5.27-4.66-2.47-3.07,5.56-6.07h1.09",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8206",
    "data-name": "Path 8206",
    d: "M210.459,15.209l-.17.01-4.7.24-16.71,11.57,1.66,3.89.01.03,4.88-.8.15-.02.24.29h.01l.09.11,1.19-1.85v-5.6l8.59-6.3h1.41",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8207",
    "data-name": "Path 8207",
    d: "M212.759,15.089l-2.3.11v1.58h-3.35l.75,1.84.73,1.77.02.06h.89l-2.67,6.05,3.12,1.58h4.75l2.6-3.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_984",
    "data-name": "Line 984",
    x1: 0.01,
    transform: "translate(1414.759 671.089)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_985",
    "data-name": "Line 985",
    x1: 0.16,
    y2: 0.01,
    transform: "translate(1414.769 671.079)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8208",
    "data-name": "Path 8208",
    d: "M217.359,25l.01-.01-4.43-9.91",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8209",
    "data-name": "Path 8209",
    d: "M210.069,36.629l-.55-1.15-2.05-.69v.07l.01,1.29v.01l2.41.45h.05l.14.03",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8210",
    "data-name": "Path 8210",
    d: "M229.419,43.249l1.09.44-.42.94-.88,1.98v.01l.62,1.46-1.51.41.27,2.4,5.38,1.88v.01l.07.02-.02-.03v-.01l-3.92-8.11-.01-.02-.08-.16-.01-.02-.53-1.12-.01-.01-.04-.07",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_986",
    "data-name": "Line 986",
    y1: 0.01,
    transform: "translate(1431.419 699.239)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8211",
    "data-name": "Path 8211",
    d: "M217.729,34.239h.17l2.37,3.85-.15.1-1.2.77-.02.01,2.28.92h.01l8.23,3.35",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8212",
    "data-name": "Path 8212",
    d: "M214.819,34.239h2.91",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8213",
    "data-name": "Path 8213",
    d: "M229.419,43.239l-6.47-13.39,3.12-8.49-6.03,2.47-.03-.06-2.06-3.9v-.01l5.86.21.14.01,2.93-1.46-11.5-3.67-.15.01-2.29.12h-.01l4.43,9.92-.06.07-2.61,3.01-.65.6v.02l.42,2.94.36,2.6",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8214",
    "data-name": "Path 8214",
    d: "M207.809,47.829l2.6-2.73h-1.03v-.65",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8215",
    "data-name": "Path 8215",
    d: "M202.049,47.479l2.41.9h.02l.01.01.04.01.91-.16h.01l.16-.03",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_987",
    "data-name": "Line 987",
    x1: 2.11,
    y2: 1.74,
    transform: "translate(1403.449 701.519)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8216",
    "data-name": "Path 8216",
    d: "M203.559,45.519h.01l5.64-1.04.05-.01.12-.02h.01v-.9",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_988",
    "data-name": "Line 988",
    x2: 0.02,
    y2: 0.02,
    transform: "translate(1405.539 701.489)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8217",
    "data-name": "Path 8217",
    d: "M193.869,46.159h-1.6l-.95.43",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_989",
    "data-name": "Line 989",
    x1: 0.01,
    y1: 0.01,
    transform: "translate(1396.469 703.959)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8218",
    "data-name": "Path 8218",
    d: "M194.119,48.089l.37-.08V48",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_990",
    "data-name": "Line 990",
    x2: 1.76,
    y2: 0.12,
    transform: "translate(1392.889 704.269)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8219",
    "data-name": "Path 8219",
    d: "M200.189,41.359l-.1.03-3.21,1h-.01l1.25,1.63",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8220",
    "data-name": "Path 8220",
    d: "M198.129,44.029h3.88l1.81-1.16.01-.01.06-.04",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8221",
    "data-name": "Path 8221",
    d: "M170.829,54.039l-.14,5.4,1.37,2.42.59.05h.01l.16.01.89-7.43-2.88-.48v.03Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_991",
    "data-name": "Line 991",
    x2: 0.02,
    y2: 0.04,
    transform: "translate(1418.969 704.709)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8222",
    "data-name": "Path 8222",
    d: "M217.019,48.809l.02.05.01-.01,1.43-2.24-.79-1.51-.01-.01h-2.46",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8223",
    "data-name": "Path 8223",
    d: "M210.079,36.639v-.01h-.01l-.13-.02V36.6l-.05-.01-2.41-.44h-.14l-.03.01-2.57.08-.01-.01-.61-.56-.13.03-3.8.93h-.35l.35,4.73,3.7,1.46h.01l.22.09,5.12.62.03.01.12.01,2.19-2.74-.37-1.04-.01-.02-.68-1.88-.03-.08Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8224",
    "data-name": "Path 8224",
    d: "M210.149,51.7l5.43-.63.23-.02.15-.02,1.5.42.16.04.68-2.1-.11-.05-1.07-.45-.04-.02-.03-.01v-.01l-.03-.04-.03-.06v-.01l-.02-.03V48.7l-1.75-3.6v-.01h-4.8l-.01.01-2.59,2.73",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8225",
    "data-name": "Path 8225",
    d: "M194.549,35.669l-.05-.2-.04-.18.58-3.25h-.17l-1.42-.02-1.13,2.55.47,1.1",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8226",
    "data-name": "Path 8226",
    d: "M197.509,34.529l-1-.98-.12.05-.76.31-.28,1.4.99-.01.5-.01H197Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_992",
    "data-name": "Line 992",
    x2: 0.9,
    y2: 1.21,
    transform: "translate(1400.139 700.039)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8227",
    "data-name": "Path 8227",
    d: "M203.569,45.509h-.01l-.01-.02h-.01l-1.53-1.46-.01-.01h-3.88",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8228",
    "data-name": "Path 8228",
    d: "M197.729,47.249h3.72l1.56-1.28.55-.45v-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8229",
    "data-name": "Path 8229",
    d: "M193.869,46.149v.01l.6,1.8h.01v.01l.01.03",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8230",
    "data-name": "Path 8230",
    d: "M199.049,45.249v.01l-2.72.79",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8231",
    "data-name": "Path 8231",
    d: "M200.9,60.049h-3.29v.82l1.23.84,1.89.29.17.03Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8232",
    "data-name": "Path 8232",
    d: "M193.669,58.789h.17v-2.92l-1.57-.46v3.38Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8233",
    "data-name": "Path 8233",
    d: "M201.839,60.169l.01.08,1.25-.73.39-2.07,1.55-.32-8.3-7.18,2.2-.13.15-.01-.66-1.24-.69-1.31-.01-.01-.04.01-.11.03h-.01l-3.08.71-.37.09-1.34.31-.13-.01-1.75-.14h-.01v.02l-.01.01v.03",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8234",
    "data-name": "Path 8234",
    d: "M190.619,49.589l-.03.12,1.9.86",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8235",
    "data-name": "Path 8235",
    d: "M193.059,53.089v1.39l.62.23.16.06.35-1.68h-1.13Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8236",
    "data-name": "Path 8236",
    d: "M191.859,43.539v-.01l-1.61-.84-.16-.09h-.01l-.66-.35-.09-.04h-.01l-3.02-1.59h-.01l-.09.05-6.44,3.87h-.17l-2.23.01v1l2.82,1.52.38,5,4.06,2.61",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8237",
    "data-name": "Path 8237",
    d: "M191.239,46.539h.01l.46-2.3",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8238",
    "data-name": "Path 8238",
    d: "M192.489,50.569l-1.89-.87.02-.11.26-1.28.01-.03v-.01l.01-.02.33-1.62.01-.07",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8239",
    "data-name": "Path 8239",
    d: "M184.739,54.749l1.29-1.67,5.96.04h.17l.17-2.54v-.01h2.37l6.8,6.79.34,2.81",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_993",
    "data-name": "Line 993",
    x2: 0.01,
    transform: "translate(1392.289 697.779)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_994",
    "data-name": "Line 994",
    x2: 0.01,
    transform: "translate(1392.279 697.789)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8240",
    "data-name": "Path 8240",
    d: "M187.839,39.7l-.08.05-1.46.87-.01.01,3.03,1.58.09.05",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8241",
    "data-name": "Path 8241",
    d: "M190.489,38.119l-.18.1-2.47,1.48,2.33,1.23h.01l.16.09",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8242",
    "data-name": "Path 8242",
    d: "M190.249,42.689l.04-.9v-.01l-.01.01-.16.08v.01l-.7.37-.01.01.67.35.17.09",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8243",
    "data-name": "Path 8243",
    d: "M177.239,31.5v3.46l1.95.18.03,2.1-1.44.79,1.27,1.84-2.53,2.4-.04.04,3.39-.62,3.46-.55.22-1.26h.7l.16-1.42-2.24-.47-2.8-6.43h-.17Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8244",
    "data-name": "Path 8244",
    d: "M174,35.129l1.38,1.86.04.05h.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8245",
    "data-name": "Path 8245",
    d: "M175.429,37.029l1.06-.37v-1.37l-2.5-.17",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8246",
    "data-name": "Path 8246",
    d: "M173.879,35.2l-2.43,1.78v3.74l1.27-.01h.17v-1.28l2.57.36.17.02-.2-2.77v-.01l-.03-.04-1.4-1.86-.01-.01-.01.01Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8247",
    "data-name": "Path 8247",
    d: "M170.879,52.159l-.04,1.84,2.88.48-.89,7.43,5.84.44.16.01,5.92-7.6-.01-.01-.11-.07h-.01l-4.06-2.6h-.17l-9.51.07Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8248",
    "data-name": "Path 8248",
    d: "M185.939,58.709h.17V57.1l-.17.15-1.68,1.46Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_995",
    "data-name": "Line 995",
    x2: 0.19,
    y2: 2.46,
    transform: "translate(1409.809 710.189)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_996",
    "data-name": "Line 996",
    y1: 1.17,
    x2: 3.65,
    transform: "translate(1410.169 711.629)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8249",
    "data-name": "Path 8249",
    d: "M207.789,54.159h.01l.02.03,2.96-.58h.01l.15-.03h.01l-.8-1.87V51.7l-.01-.01v-.01l-2.32-3.85h-.01l-.14.03-2.06.35v.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_997",
    "data-name": "Line 997",
    y2: 0.01,
    transform: "translate(1408.309 708.089)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8250",
    "data-name": "Path 8250",
    d: "M202.039,47.489l.01-.01-.6-.22h-3.73l.71,1.31.67,1.24h.01v.01l.17-.01.18-.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8251",
    "data-name": "Path 8251",
    d: "M215.219,54.529l.03,1.75h2.61l-1.05-2.27h-.01l-.02.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_998",
    "data-name": "Line 998",
    x1: 1.44,
    y2: 0.46,
    transform: "translate(1417.219 710.059)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8252",
    "data-name": "Path 8252",
    d: "M205.8,49.239l-.17.02-3.7.5v.01",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8253",
    "data-name": "Path 8253",
    d: "M203.549,53.249l.81.2h.02l.11.03,1.71-1.3v-.01l.11-.08-.51-2.84",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8254",
    "data-name": "Path 8254",
    d: "M206.609,57.309h-.01l1.21,1.39,2.33.65-1.42.6,1.79,2.25.09.12,1.18-1.87-1.32-2.88,2.62-1.29h2.16l-.02-1.75v-.01l-.17.05-3.23,1.05-3.65,1.18-.15.05-.72.24",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8255",
    "data-name": "Path 8255",
    d: "M205.449,48.249l-.92.16-.04-.02h-.03v-.01l-2.42-.89-.02.04-.01.01-.77,1.33-1.77.93h-.01l-.01.01.46-.03.16-.01,2.88,3.33.41.1.19.05-1.62-3.48,3.7-.5h.01l.16-.02v-.01l-.19-1.02Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8256",
    "data-name": "Path 8256",
    d: "M206.989,53.039l-.68-.94-.1.08h-.01l-1.7,1.31,1.01.25.12.03",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8257",
    "data-name": "Path 8257",
    d: "M205.629,53.769l.76,3.3.18.2.04.04.69-.22.72-.23V56.8l-.02-.15-.18-2.45v-.01h-.01l-.02-.03-.8-1.12-.12.06v.01Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8258",
    "data-name": "Path 8258",
    d: "M211.819,55.629l3.23-1.04.17-.06,1.44-.47.12-.04h.02v-.01l.82-2.5-.16-.04-1.5-.42-.09.01h-.03l-5.69.65h-.01l.8,1.87.86,1.99v.01l.02.04Z",
    transform: "translate(1202 656)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsiaPacificCore);
export default __webpack_public_path__ + "static/media/asia_pacific_core.85199961c1d419a0519bcc0cf23cb42f.svg";
export { ForwardRef as ReactComponent };